<template>
    <Attr :widget_id="widget_id" :attr_id="attr_id">
        <!-- IE 2026 09 15 / ODOO-… (замечания Игоря: пузырьковый график в общей канве графика): островки как у графика и карты, легенда
             Grouped / Popup + Legend position, оси с Compact, плашка узла с чекбоксом отбора и иконкой открытия записи, все строки — English -->
        <div class="attr-bubble-chart" ref="attr_container" v-wjTooltip="attr.tooltip" :id="'vueObj'+attr_id" v-visible="legendOwner_onVisible" :class="stripSide ? 'bubble-strip-' + stripSide : ''">
            <div class="bubble-chart-empty" v-if="configError" v-uiHelp="'chart.bubble.configError'">{{ configError }}</div>
            <!-- быстрые настройки чарта (как у AttrChart): значения живут в
                 doc.viewParams.<attr.name>.*, поэтому сохраняются с виджетом -->
            <div class="grid-commandPanel-top-right widget-commandPanel-2" v-show="show_settings"
                @mouseenter="onShow_settings" @mouseleave="onClose_settings">
                <div class="ml-1">
                    <div class="widget-commandPanel-row mb-2" v-for="(row, rowIndex) in commandPanel_topLeft" :key="'row-'+rowIndex">
                        <component v-for="attrM in row" :key="attrM.html_id"
                            :widget_id="widget_id" :is="attrM.component" :attr_id="attrM.id" :initialAttr="attrM" />
                    </div>
                </div>
            </div>
            <!-- IE 2026 09 15 / ODOO-… (заказ Игоря): угловые кнопки — островком в ряд: легенда, сброс масштаба, шестерёнка -->
            <div class="corner-island corner-island-tr" v-if="!configError">
                <!-- ODOO-4440: попап-легенда классов (общее окно ChartLegendPanel);
                     при открытой панели полоса классов под чартом прячется. IE 2026 09 15: кнопка — в режиме Grouped (как у графика) -->
                <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                <div class="button-lt bubble-legend-btn p-2" v-if="cfLevelTasks.length && legendGrouped"
                    :class="{'chart-legend-btn-on': levelsPanelVisible}"
                    v-wjTooltip="levelsPanelVisible ? t('Hide legend') : t('Show legend')"
                    @click="levelsPanelVisible = !levelsPanelVisible" v-uiHelp="{ key: 'chart.bubble.legendBtn', state: () => (levelsPanelVisible ? 'on' : 'off') }">
                    <i class="pi pi-tags"/>
                </div>
                <div class="button-lt p-2" ref="cogButton"
                    @click="onToggle_settings" v-uiHelp="{ key: 'chart.bubble.cog', state: () => (show_settings ? 'open' : 'closed') }" @mouseenter="onShow_settings" @mouseleave="onClose_settings">
                    <i class="pi pi-cog"/>
                </div>
            </div>
            <!-- IE 2026 09 15 / ODOO-… (замечание Игоря): масштаб — островок (+, −, сброс) в нижнем ПРАВОМ углу (вечером 15.09 — перенос из левого);
                 подпись оси X в Compact уходит левее островка (axisTitleXStyle по замеру zoomBox) -->
            <div class="corner-island corner-island-br bubble-zoom-island" ref="zoomIsland" v-if="!configError && attr['bubble_gestures'] !== false" :style="zoomIslandStyle">
                <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                <span class="bubble-zoombtn" v-wjTooltip="t('Zoom in')" @click="zoomBy(1)" v-uiHelp="'chart.bubble.zoomIn'"><i class="pi pi-plus"/></span>
                <span class="bubble-zoombtn" v-wjTooltip="t('Zoom out')" @click="zoomBy(-1)" v-uiHelp="'chart.bubble.zoomOut'"><i class="pi pi-minus"/></span>
                <span class="bubble-zoombtn" v-wjTooltip="t('Reset zoom')" @click="resetZoom" v-uiHelp="'chart.bubble.zoomReset'"><i class="pi ie-ico-fit"/></span>
            </div>
            <!-- IE 2026 09 15 (замечание Игоря): Compact — заголовки осей не отнимают поля, а лежат подписями внутри области -->
            <div v-if="!configError && compactY && titleY" class="bubble-axis-title bubble-axis-title-y" v-uiHelp="'chart.bubble.axisTitle'" :style="axisTitleYStyle">{{ titleY }}</div>
            <div v-if="!configError && compactX && !xIsDateAxis && titleX" class="bubble-axis-title bubble-axis-title-x" :style="axisTitleXStyle">{{ titleX }}</div>
            <wj-flex-chart
                v-if="!configError"
                :id="attr.html_id"
                :initialized="initializeChart"
                :itemsSource="rows"
                :bindingX="bindingX"
                chartType="Bubble"
                selectionMode="Point"
                :tooltipContent="tooltipContent"
                :itemFormatter="itemFormatter"
                @click="chart_onClick" v-uiHelp="'chart.bubble.plot'"
                v-wjContextMenu="'ContextWidgetMenuId'"
            >
                <wj-flex-chart-series :binding="seriesBinding" :name="seriesName" />
                <!-- зум и панорама колесом/жестом: разброс по обеим осям в тысячи раз,
                     без масштабирования точки слипаются у нуля (ODOO-4428).
                     interactiveAxes ОБЯЗАТЕЛЕН: по умолчанию у wijmo это X, поэтому
                     scaleY задавался, а вертикальный зум колесом не работал (ODOO-4430) -->
                <wj-flex-chart-gestures v-if="attr['bubble_gestures'] !== false"
                    :initialized="initializeGestures"
                    :interactiveAxes="attr['bubble_axes'] || 'XY'"
                    :scaleX="numOrNull(attr['bubble_scaleX']) ?? 1"
                    :scaleY="numOrNull(attr['bubble_scaleY']) ?? 1" />
                <!-- IE 2026 09 15: штатная легенда wijmo (имя серии) — только вне режима Grouped, как у графика -->
                <wj-flex-chart-legend :position="wjLegendPosition" />
                <!-- IE 2026 09 10 / ODOO-5800: itemFormatter — подписи оси-длительности (DOS в секундах) в месяцах/днях -->
                <!-- IE 2026 09 15 (замечание Игоря): положение осей (Axis X / Y position) и Compact (заголовок оси — подписью внутри области) -->
                <wj-flex-chart-axis wjProperty="axisX" :title="compactX && !xIsDateAxis ? '' : titleX" :format="attr['axisX-format']" :itemFormatter="axisFormatterX"
                    :position="axisPositionX" :logBase="+attr['axisX-logBase'] || 0" :min="numOrNull(attr['axisX-min'])" :max="numOrNull(attr['axisX-max'])" />
                <wj-flex-chart-axis wjProperty="axisY" :title="compactY ? '' : titleY" :format="attr['axisY-format']" :itemFormatter="axisFormatterY"
                    :position="axisPositionY" :logBase="+attr['axisY-logBase'] || 0" :min="numOrNull(attr['axisY-min'])" :max="numOrNull(attr['axisY-max'])" />
            </wj-flex-chart>
            <!-- легенда классов обеспеченности (ODOO-4443): классы и названия — из
                 правил условного оформления на мере уровня; пороги — фолбэк -->
            <!-- легенда целиком из правил условного оформления поля-раскраски:
                 «норма» — такое же правило (титул правится в редакторе правил),
                 хардкода подписей здесь больше нет -->
            <!-- IE 2026 09 23 / ODOO-341407: i18n — переменная цикла переименована (t — словарь) -->
            <div class="bubble-levels" v-if="stripSide && cfLevelTasks.length" v-uiHelp="'chart.bubble.classStrip'">
                <span v-for="(lt, i) in cfLevelTasks" :key="i"
                    :class="{'bubble-level-clickable': legendToggleOn,
                             'bubble-level-off': legendToggleOn && hiddenLevels[lt.title || '…']}"
                    v-wjTooltip="legendToggleOn ? (hiddenLevels[lt.title || '…'] ? t('Show class') : t('Hide class')) : ''"
                    @click="legendToggleOn && onLevelToggle({ levelTitle: lt.title || '…' })"><i :style="{background: cfTaskColorOf(lt)}"></i>{{ lt.label || lt.title || '…' }}</span><!-- IE 2026 09 27 / ODOO-341407: подпись класса — label (язык интерфейса), ключ скрытия — базовый title -->
            </div>
            <!-- IE 2026 09 23 / ODOO-341407: i18n -->
            <div class="bubble-levels" v-else-if="stripSide && levelsOn">
                <span v-if="levelLow !== null"><i :style="{background: attr.bubble_level_lowColor || '#c9302c'}"></i>{{ t('Shortage') }} &lt; {{ levelLow }}</span><!-- IE 2026 09 15: UI strings English -->
                <span><i :style="{background: attr.bubble_level_midColor || '#4a90d9'}"></i>{{ t('Normal') }}</span>
                <span v-if="levelHigh !== null"><i :style="{background: attr.bubble_level_highColor || '#b98514'}"></i>{{ t('Surplus') }} &gt; {{ levelHigh }}</span>
            </div>
            <!-- попап-легенда классов: общее окно легенды (вынос ODOO-4646);
                 «серии» = классы категорий с шариком цвета и счётчиком точек,
                 тумблер прячет точки класса -->
            <ChartLegendPanel
                :WIDGET="WIDGET" :flex="flex" :groups="levelGroups"
                :rows="[]" :attrsByBinding="{}" :valueColumn="false"
                :hoverBinding="legendHoverBinding" :footer="legendFooter"
                :visible="levelsPanelVisible && legendGrouped && !configError && legendOwner_shown()"
                @series-toggle="onLevelToggle"
                @group-toggle="onLevelGroupToggle"
                @series-settings="onLevelSettings"
                @close="levelsPanelVisible = false"
            />
            <!-- плашка точки: те же данные, что в подсказке, плюс кнопка отбора
                 (ODOO-4429 — вместо модального вопроса браузера) -->
            <!-- IE 2026 09 16 (замечание Игоря): по наведению на узел — плашка с его ИЗМЕРЕНИЯМИ (чекбокс отбора + открыть запись), клик по узлу
                 прикалывает её (повторный клик / клик мимо / Esc — закрыть); показатели узла — в окне легенды (нижний блок, класс подсвечен);
                 пока окно легенды закрыто, показатели остаются в плашке -->
            <!-- IE 2026 09 16 (уточнение Игоря): без заголовка, строки в одну строку с «…» и подсказкой полного текста; плашка по наведению
                 показывается только в режиме, включённом кликом по узлу (повторный клик по любому узлу выключает) -->
            <div v-if="picker" ref="picker_panel" class="bubble-picker" v-uiHelp="'chart.bubble.picker'"
                :style="{ left: picker.x + 'px', top: picker.y + 'px' }" @click.stop @mouseenter="pickerHoverIn" @mouseleave="pickerHoverOut">
                <template v-if="!legendWindowOn">
                    <!-- IE 2026 09 16 (уточнение Игоря): без окна легенды плашка группирует показатели как легенда — Bubble size, X axis, Y axis, остальное -->
                    <template v-for="g in pickerGroups().heads" :key="'h' + g.key">
                        <div class="bubble-picker-head"><i :class="g.cls"></i>{{ g.head }}</div>
                        <div class="bubble-picker-row bubble-picker-measure bubble-picker-keyrow" :title="g.row.title + ': ' + String(g.row.value || '').replace(/<[^>]+>/g, '')">
                            <span class="bubble-picker-name">{{ g.row.title }}:</span><span class="bubble-picker-value" v-html="g.row.value"></span>
                        </div>
                    </template>
                    <div class="bubble-picker-sep" v-if="pickerGroups().heads.length && pickerGroups().rest.length"></div>
                    <div v-for="(r, i) in pickerGroups().rest" :key="'m'+i" class="bubble-picker-row bubble-picker-measure" :title="r.title + ': ' + String(r.value || '').replace(/<[^>]+>/g, '')">
                        <span class="bubble-picker-name">{{ r.title }}:</span>
                        <i v-if="r.color" class="bubble-picker-dot" :style="{background: r.color}"></i>
                        <span class="bubble-picker-value" v-html="r.value"></span>
                    </div>
                    <div class="bubble-picker-sep" v-if="pickerRows().length"></div>
                </template>
                <!-- IE 2026 09 15 (замечание Игоря): измерения узла — как строки формы чипса: чекбокс отбора (клик — добавить / снять узел,
                     Alt+клик — оставить только его; у узла с несколькими измерениями отбор парный) и иконка сегмента — открыть запись;
                     кнопок «Отобрать / Закрыть» нет: закрытие — Esc или клик мимо -->
                <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                <div v-for="(r, i) in pickerRows()" :key="'d'+i" class="bubble-picker-row bubble-picker-dim" :title="r.title + ': ' + r.value">
                    <i v-if="canSelect" class="pi bubble-picker-check" :class="picker.active ? 'pi-check-square' : 'pi-stop'"
                        :title="picker.active ? t('Click — remove the point from the selection') : t('Click — add the point to the selection · Alt+click — only this point')"
                        @click.stop="pickerToggle($event)" v-uiHelp="{ key: 'chart.bubble.picker.check', state: () => (picker.active ? 'on' : 'off') }"></i>
                    <i v-if="r.segment" :class="['pi', 'bubble-picker-open', r.pi]" :title="t('Open {title}', { title: r.value })" @click.stop="pickerOpen(r)" v-uiHelp="'chart.bubble.picker.open'"></i>
                    <span class="bubble-picker-name">{{ r.title }}:</span><span class="bubble-picker-value">{{ r.value }}</span>
                </div>
                <div v-if="!canSelect && pickerRows().length" class="bubble-picker-hint">{{ t('Set the widget «{name}» (selector fields) to select points', { name: t('Set dimensions') }) }}</div><!-- IE 2026 09 27 / ODOO-341407: имя настройки «Set dimensions» — своим ключом словаря (как на бэке: Задати виміри / Задать измерения), а не английским внутри перевода фразы -->
            </div>
            <!-- IE 2026 09 16 (замечание Игоря): Shift + протяжка — прямоугольник выбора узлов, итоги по ним — в окне легенды -->
            <div v-if="rectBox" class="bubble-rect-sel" v-uiHelp="'chart.bubble.rectSel'" :style="{ left: rectBox.x + 'px', top: rectBox.y + 'px', width: rectBox.w + 'px', height: rectBox.h + 'px' }"></div>
        </div>
    </Attr>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'
import { uiHelp_html, uiHelp_enabled } from '@/utils/uiHelp'   // U6 (заказ Игоря: объяснение элементов по Alt): chart.bubble.point — источник «по точке»
import { Rect } from '@mescius/wijmo'   // U6: подсказка пузырька — у самого пузырька
import * as wjChart from '@mescius/wijmo.chart'
// АН 2026 08 15 / ODOO-4997: ярусные подписи датной оси (ярус годов рисуем
// сами в rendered — wijmo-группы позиционируются по ИНДЕКСУ строки данных,
// а у баблов много точек на одну дату, и подписи улетали за правый край)
import { Point } from '@mescius/wijmo'
// ODOO-4443 этап 2: раскраска точек правилами условного оформления Игоря
import { cfCheckWHERE, cfTaskColor, cfFieldTasks } from '@/utils/cfEval'
// ODOO-4440: попап-легенда классов — общее окно легенды (вынос ODOO-4646)
import ChartLegendPanel from './ChartLegendPanel.vue'
import { legendOwnerMixin } from '@/utils/legendOwner'   // IE 2026 09 20 / ODOO-… (Игорь: легенда закрывается вместе с виджетом и на вкладке, к которой не относится)
import { getLanguage, LANGUAGE_DEFAULT } from '@/i18n'   // IE 2026 09 27 / ODOO-341407: подписи осей / плашки / классов — вариант языка {key}_{lang}
import nativeTitles from '@/utils/nativeTitles'   // IE 2026 09 27 / ODOO-341407: полный текст урезанного заголовка оси — по правилу подсказок (Alt / Show tooltips)
import { chartClickSel_on, chartClickSel_selectors, chartClickSel_rowTarget, chartClickSel_current, chartClickSel_decide } from '@/utils/chartClickSelectors'   // IE 2026 10 13 / ODOO-5800: клик по пузырю (dims) — сразу селекторы стола, плашка — Shift / Alt / Ctrl / правая кнопка (флаг fe.ux.chartClickSelectors)
import { headerReserveTop } from '@/utils/vizHeaderFit'   // IE 2026 09 28 / ODOO-341407: верх области — ниже островков парящей шапки

// ODOO-4143: пузырьковая диаграмма. Точка = строка выборки, X / Y / размер — ЛЮБЫЕ
// меры виджета, заданные параметрами (bubble_x / bubble_y / bubble_size), а не хардкод.
// Формат биндинга серии в wijmo для Bubble — 'yProperty,bubbleSizeProperty';
// ось X идёт отдельным bindingX. Диапазон радиусов — options.bubble.minSize/maxSize.
// Кейс постановки: точка = товар×склад, Y = DOS, X = продажи, размер = uncovered.
// U6 (заказ Игоря: объяснение элементов по Alt): ключ объяснения ряда быстрых настроек — по имени параметра (param первого
// аргумента opt()); один ключ на все кнопки ряда (в т.ч. AttrLabel ряда), state читает ТЕКУЩЕЕ состояние в момент показа подсказки
const UI_HELP_QS_BUBBLE = {
    bubble_axes: 'chart.bubble.qs.wheelZoom', bubble_gestures: 'chart.bubble.qs.wheelZoom',
    'axisX-logBase': 'chart.bubble.qs.logScale', 'axisY-logBase': 'chart.bubble.qs.logScale',
    'axisY-position': 'chart.bubble.qs.axisYPos', 'compact-axisY': 'chart.bubble.qs.compactY',
    'axisX-position': 'chart.bubble.qs.axisXPos', 'compact-axisX': 'chart.bubble.qs.compactX',
    'legend-position': 'chart.bubble.qs.legendPos',
}
const UI_HELP_QS_BUBBLE_STATE = {
    bubble_axes: (vm) => (vm.attr.bubble_gestures === false ? 'off' : (vm.attr.bubble_axes || 'XY')),
    bubble_gestures: (vm) => (vm.attr.bubble_gestures === false ? 'off' : (vm.attr.bubble_axes || 'XY')),
    'axisX-logBase': (vm) => ((vm.attr['axisX-logBase'] ? 'X' : '') + (vm.attr['axisY-logBase'] ? 'Y' : '') || 'none'),
    'axisY-logBase': (vm) => ((vm.attr['axisX-logBase'] ? 'X' : '') + (vm.attr['axisY-logBase'] ? 'Y' : '') || 'none'),
    'axisY-position': (vm) => (vm.attr['axisY-position'] || 'Auto'),
    'compact-axisY': (vm) => (vm.compactY ? 'on' : 'off'),
    'axisX-position': (vm) => (vm.attr['axisX-position'] || 'Auto'),
    'compact-axisX': (vm) => (vm.compactX ? 'on' : 'off'),
    'legend-position': (vm) => (vm.attr['legend-position'] || 'Auto'),
}
export default {
    components: { ChartLegendPanel },
    mixins: [legendOwnerMixin],   // IE 2026 09 20 / ODOO-… (Игорь: легенда закрывается вместе с виджетом и на вкладке, к которой не относится)
    props: [
        'widget_id',
        'attr_id',
    ],
    data: () => ({
        // ODOO-4440: попап-легенда классов (общее окно) и скрытые классы
        levelsPanelVisible: false,
        hiddenLevels: {},
        WIDGET: {},
        // attr приходит присваиванием из store.widget_attr_set — объявляем его здесь,
        // иначе свойство не реактивно и вычисляемые от него не пересчитываются
        attr: {},
        flex: null,
        gestures: null,
        // плашка выбранной точки: {row, bindings, active, x, y, pinned}
        picker: null,
        hoverRow: null,     // IE 2026 09 16: узел под курсором (показатели — в окно легенды)
        hoverFormMode: false, // IE 2026 09 16 (уточнение Игоря): плашка измерений по наведению — режим, включаемый кликом по узлу
        selectedRow: null,    // IE 2026 09 16 (уточнение Игоря): узел, выбранный кликом — окно легенды держит его показатели, пока курсор не на другом узле
        rectSel: [],        // IE 2026 09 16: узлы, выделенные прямоугольником (Shift + протяжка) — итоги в окне легенды
        rectBox: null,      // прямоугольник выделения {x, y, w, h} относительно контейнера
        levelsBox: { w: 0, h: 0 },   // IE 2026 09 15: размер полосы классов (островок масштаба и подписи осей — над ней)
        zoomBox: { w: 0 },   // IE 2026 09 15 (замечание Игоря): ширина островка масштаба (нижний правый угол) — подпись оси X левее него
        // быстрые настройки (шестерёнка), как в AttrChart
        show_settings: false,
        commandPanel_topLeft: [],
        timerId_settings: null,
    }),
    setup() {
        const store = useMainStore()
        return { store }
    },
    created() {
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        this.content_Changed()
    },
    mounted() {
        // IE 2026 09 24 / ODOO-341407 (второй обход dev02: месяцы на оси X после живого переключения языка): подписи дат оси X считаются
        // computeXAxisDates на языке интерфейса — после перелокализации (phase 'attrs') пересчитать и переставить (только в датном режиме)
        this._i18nHandler = (ev) => {
            if (ev?.detail?.phase !== 'attrs') return
            try {
                const ax = this.flex?.axisX
                if (!ax || !this._xAxisDates) return
                this._xAxisDates = this.computeXAxisDates()
                if (this._xAxisDates) ax.itemsSource = this._xAxisDates.map(it => ({ value: it.value, text: it.text }))
                this.flex.invalidate?.()
            } catch (e) { console.warn('[i18n] bubble chart relabel', e) }
        }
        window.addEventListener('i18n:changed', this._i18nHandler)
        // высоту чарта задаёт виджет, а не содержимое (см. attrResize) — как в AttrChart
        this.WIDGET.attrsResize?.push(this.attrResize)
        this.$nextTick(() => this.attrResize())
        this.set_commandsActive()
        // миграция: чипы первой реализации отбора (CHIP-Where с meta.bubble_key)
        // могли остаться в сессии и молча фильтровать выборку — вычищаем
        const chips = this.WIDGET?.record?.doc?.viewParams?.dataSheet?.CHIPS
        if (Array.isArray(chips)) {
            for (let i = chips.length - 1; i >= 0; i--) {
                if (chips[i]?.segment === 'CHIP-Where' && chips[i]?.meta?.bubble_key) chips.splice(i, 1)
            }
        }
        // миграция: до групп (bubble_pair_group) каждый бабл вёл СВОЮ SEL-строку пар —
        // свою вливаем в строку группы (или назначаем группой), иначе осиротевшая
        // строка продолжает резать calc-пересечение уже невидимым набором
        if (this.pairGroup) {
            const WHERE = this.store.WORKSPACES?.[this.WIDGET?.workspace]?.record?.doc?.params?.WHERE
            if (Array.isArray(WHERE)) {
                const own = WHERE.find(w => w?.meta?.bubble_pair && !w.meta.pair_group && w?.widget === this.WIDGET.widget)
                if (own) {
                    const groupRow = WHERE.find(w => w?.meta?.bubble_pair && w.meta?.pair_group === this.pairGroup)
                    if (!groupRow) {
                        own.meta.pair_group = this.pairGroup
                        own.leftValue = { ...own.leftValue, value: `bubble-pair::${this.pairGroup}` }
                    } else {
                        const dst = groupRow.attrs?.[0]?.attrs
                        const add = own.attrs?.[0]?.attrs
                        if (Array.isArray(dst) && Array.isArray(add)) dst.push(...add)
                        WHERE.splice(WHERE.indexOf(own), 1)
                    }
                }
            }
        }
        document.addEventListener('mousedown', this.picker_onOutside, true)
        window.addEventListener('keydown', this.picker_onEscape, true)   // IE 2026 09 16: на window — раньше захвата App.handleKeydown (document, capture), который закрывает активный виджет по Esc
        // IE 2026 09 15 (замечание Игоря: подсказка и плашка одновременно — избыточно): пока открыта плашка, подсказка wijmo гасится
        // на каждом движении мыши (после клика она успевала показаться заново)
        this.$refs.attr_container?.addEventListener('mousemove', () => { if (this.picker) this.flex?.tooltip?.hide?.() }, { passive: true })
        // АН 2026 08 15 / ODOO-4997 (заказ Игоря): двунаправленный канал подсветки
        // измерений между виджетами страницы. Приём — ТОЛЬКО тихое выделение,
        // без ре-эмита (защита от каскадного зацикливания by construction).
        this._dimHlHandler = (ev) => this.applyDimHighlight(ev?.detail)
        window.addEventListener('wscm-dim-highlight', this._dimHlHandler)
        // IE 2026 09 28 / ODOO-341407: шапка виджета перераскладена (бейдж уступил место заголовку, язык, Stop loading) — верх области под её островками перемерить
        // (сам график при этом не перерисовывается); не чаще раза в кадр
        this._hdrFitEl = this.$refs.attr_container?.closest?.('.WIDGET') || null
        this._hdrFitHandler = () => { if (this._hdrFitRaf) return; this._hdrFitRaf = requestAnimationFrame(() => { this._hdrFitRaf = null; this.axisFit() }) }
        this._hdrFitEl?.addEventListener('viz-header-fit', this._hdrFitHandler)
    },
    unmounted() {
        if (this._hdrFitEl && this._hdrFitHandler) this._hdrFitEl.removeEventListener('viz-header-fit', this._hdrFitHandler)   // IE 2026 09 28 / ODOO-341407
        if (this._hdrFitRaf) { cancelAnimationFrame(this._hdrFitRaf); this._hdrFitRaf = null }   // IE 2026 09 28 / ODOO-341407
        if (this._i18nHandler) { window.removeEventListener('i18n:changed', this._i18nHandler); this._i18nHandler = null }   // IE 2026 09 24 / ODOO-341407
        if (this._hoverRaf) { cancelAnimationFrame(this._hoverRaf); this._hoverRaf = null }   // IE 2026 09 15
        this.pickerCloseCancel(); document.removeEventListener('pointermove', this.rect_onMove, true); document.removeEventListener('pointerup', this.rect_onUp, true)   // IE 2026 09 16
        document.removeEventListener('mousedown', this.picker_onOutside, true)
        window.removeEventListener('keydown', this.picker_onEscape, true)   // IE 2026 09 16
        if (this._dimHlHandler) window.removeEventListener('wscm-dim-highlight', this._dimHlHandler)
    },
    computed: {
        // Поля виджета: у узла dataBubble своих attrs нет (в отличие от AttrChart),
        // поэтому берём меры и измерения из viewList виджета — иначе список пуст
        // и титулы мер вырождаются в binding (ODOO-4427).
        fields() {
            return this.store.fieldsNoHierarchy(
                this.attr?.attrs?.length
                    ? this.attr.attrs
                    : (this.WIDGET?.record?.doc?.viewList || this.WIDGET?.record?.doc?.fields || [])
            )
        },
        // меры — источник и для дефолтов осей, и для заголовков
        measures() {
            return this.fields.filter(a => a.attr_type === 'AttrNumber' || a.attr_type === 'AttrDays' || a.attr_type === 'AttrTime') // IE 2026 09 10 / ODOO-5800: DOS в секундах
        },
        bindingXRaw() {
            return this.attr?.bubble_x || this.measures[0]?.binding || ''
        },
        bindingX() {
            // АН 2026 08 15 / ODOO-4997: датная ось — категориальная по индексу.
            // Режим вычисляется по данным БЕЗ мутации состояния (мутация в computed
            // давала «Maximum recursive updates»)
            // IE 2026 09 16 (заказ Игоря: метрики пузырьками): строковое поле (горизонт, категория) — тоже категориальная ось по индексу
            if (this.xDetectDate() || this.xDetectCat()) return '__x_idx'
            return this.bindingXRaw
        },
        bindingYRaw() {
            return this.attr?.bubble_y || this.measures[1]?.binding || ''
        },
        bindingY() {
            return this.yDetectCat() ? '__y_idx' : this.bindingYRaw   // IE 2026 09 16: категориальная ось Y (строки матрицы) — по индексу
        },
        // IE 2026 09 16: поле для показа значения узла (подписи, плашка, легенда) — исходное, не индекс
        displayBindingX() { return this.bindingX === '__x_idx' ? this.bindingXRaw : this.bindingX },
        displayBindingY() { return this.bindingY === '__y_idx' ? this.bindingYRaw : this.bindingY },
        xIsCatAxis() { return this.bindingX === '__x_idx' && !this.xDetectDate() },
        yIsCatAxis() { return this.bindingY === '__y_idx' },
        bindingSize() {
            return this.attr?.bubble_size || this.measures[2]?.binding || ''
        },
        seriesBinding() {
            // 'y,size' — обязательная форма для ChartType.Bubble
            return this.bindingSize ? `${this.bindingY},${this.bindingSize}` : this.bindingY
        },
        seriesName() {
            return this.measureTitle(this.bindingSize) || this.attr?.title || this.t('Bubble')   // IE 2026 09 23 / ODOO-341407: i18n
        },
        titleX() { return this.attrText('bubble_x_title') || this.measureTitle(this.bindingXRaw) },   // IE 2026 09 27 / ODOO-341407: bubble_x_title_{lang}
        titleY() { return this.attrText('bubble_y_title') || this.measureTitle(this.bindingYRaw) },   // IE 2026 09 27 / ODOO-341407: bubble_y_title_{lang}
        // IE 2026 09 10 / ODOO-5800: датная ось X — категориальная (__x_idx), форматтер длительности к ней не применяем
        axisFormatterX() { return this.bindingX === '__x_idx' ? null : this.axisDurationFormatter(this.bindingX) },
        axisFormatterY() { return this.yIsCatAxis ? null : this.axisDurationFormatter(this.bindingY) },   // IE 2026 09 16: категории — подписи из itemsSource
        titleSize() { return this.attrText('bubble_size_title') || this.measureTitle(this.bindingSize) },   // IE 2026 09 27 / ODOO-341407: bubble_size_title_{lang}
        // Данные читаем ВЫЧИСЛЯЕМЫМ, а не по событию: выборка приходит уже после
        // created(), а content_Changed зовётся не на каждом обновлении _doc.data —
        // на реактивном чтении точки появляются сами, когда данные доехали.
        rows() {
            const [doc, binding] = this.store.attr_get_link(this.WIDGET, this.attr) || []
            const data = (doc || {})[binding]
            if (!Array.isArray(data) || !this.bindingY) return []

            // строки без числа по осям wijmo пропускает молча, но пустые значения
            // портят расчёт диапазона размеров — отбираем сами.
            // Меры из выборки приходят и строками ('90.2') — wijmo их НЕ приводит и
            // молча не рисует серию: приводим к числу сами, остальные поля не трогаем
            // (по ним строится тултип и подпись точки).
            const bx = this.bindingXRaw, by = this.bindingYRaw, bs = this.bindingSize   // IE 2026 09 16: исходные поля (индексы категорий — ниже)
            // __src — ссылка на ОРИГИНАЛЬНУЮ строку выборки: отбор ставится флагом
            // row.selector на ней (штатный селектор воркспейса), а не на копии
            // скрытые классы (попап-легенда, ODOO-4440): точки класса не рисуем
            const hidden = this.hiddenLevels
            const hasHidden = Object.values(hidden).some(Boolean)
            // АН 2026 08 15 / ODOO-4997 (заказ Игоря): ось X по ДАТАМ как в Chart —
            // если значение X не число, а ISO-дата ('2026-09' / '2026-09-01'),
            // конвертируем в Date: wijmo рисует временную ось. Числовые виджеты
            // не затронуты (авто-режим только для ISO-строк).
            const xDate = (v) => {
                if (typeof v !== 'string' || !/^\d{4}-\d{2}(-\d{2})?/.test(v)) return null
                const d = new Date(v.length === 7 ? v + '-01' : v.slice(0, 10))
                return isNaN(d.getTime()) ? null : d
            }
            const xIsDate = this.xDetectDate()
            // датная ось — КАТЕГОРИАЛЬНАЯ с ярусами (месяц + группа-год), как в
            // AttrChart: точки получают индекс даты (__x_idx) и поля группировки
            const dateIdx = new Map()
            if (xIsDate) {
                const ds = [...new Set(data.filter(r => r && xDate(r[bx])).map(r => xDate(r[bx]).getTime()))].sort((a, z) => a - z)
                ds.forEach((t, i) => dateIdx.set(t, i))
            }
            // IE 2026 09 16 (заказ Игоря: метрики пузырьками): категориальные оси — строковые значения X / Y получают индекс категории
            // (__x_idx / __y_idx), подписи и порядок — catList (поле порядка bubble_x_order / bubble_y_order)
            const xCat = !xIsDate && this.xDetectCat(), yCat = this.yDetectCat()
            const xCatIdx = new Map((xCat ? this.catList(bx, this.attr?.bubble_x_order) : []).map(c => [c.key, c.value]))
            const yCatIdx = new Map((yCat ? this.catList(by, this.attr?.bubble_y_order) : []).map(c => [c.key, c.value]))
            const okX = (r) => xIsDate ? !!xDate(r[bx]) : (xCat ? xCatIdx.has(String(r[bx])) : Number.isFinite(+r[bx]))
            const okY = (r) => yCat ? yCatIdx.has(String(r[by])) : Number.isFinite(+r[by])
            const arr = data
                .filter(r => r && okX(r) && okY(r)
                    && (!bs || Number.isFinite(+r[bs]))
                    && (!hasHidden || !hidden[this.matchedLevelTitle(r)]))
                .map(r => {
                    const out = { ...r, ...(yCat ? { __y_idx: yCatIdx.get(String(r[by])) } : { [by]: +r[by] }), ...(bs ? { [bs]: +r[bs] } : {}), __src: r }
                    if (xIsDate) {
                        out.__x_idx = dateIdx.get(xDate(r[bx]).getTime())
                    } else if (xCat) out.__x_idx = xCatIdx.get(String(r[bx]))
                    else out[bx] = +r[bx]
                    return out
                })
            // подписи оси считает computeXAxisDates() из watcher'а rows —
            // side effect в computed запрещён (eslint валит сборку оверлеем)
            // отобранные — В КОНЕЦ: wijmo рисует по порядку, и рыжая отметка иначе
            // тонет под точками соседей (репорт Андрея 09.08); чтение r.__src.selector
            // здесь же делает rows реактивными к смене флагов — чарт перерисуется сам
            if (arr.some(r => r.__src.selector)) {
                const sel = [], rest = []
                for (const r of arr) (r.__src.selector ? sel : rest).push(r)
                return [...rest, ...sel]
            }
            return arr
        },
        configError() {
            // без меры Y рисовать нечего — говорим прямо, а не пустым полотном
            return this.bindingY ? ''
                : this.t('Bubble chart: no measures set. Set the X / Y / Size bindings in the widget settings')   // IE 2026 09 15: UI strings English   // IE 2026 09 23 / ODOO-341407: i18n
        },
        // ---- IE 2026 09 16 (замечание Игоря): показатели узла — в окно легенды: класс узла подсвечен, значения в нижнем блоке;
        // несколько узлов (прямоугольник) — итоги
        legendWindowOn() { return !!(this.levelsPanelVisible && this.legendGrouped && !this.configError) },
        legendHoverBinding() {
            const row = this.hoverRow || (this.picker && this.picker.row) || null
            if (!row) return null
            const t = this.matchedLevelTitle(row.__src || row)
            return t ? `level::${t}` : null
        },
        // IE 2026 09 16 (уточнение Игоря): без заголовка измерений (они — в плашке над узлом); сначала мера размера пузырька своим
        // блоком, за разделителем — остальные реквизиты; без узла под курсором — те же строки с пустыми значениями (заделы)
        legendFooter() {
            // блоки «Bubble size», «X axis», «Y axis» — отдельно (IE 2026 09 16, замечание Игоря), остальные реквизиты — таблицей ниже
            const split = (rows, extra) => ({ size: rows.find(r => r.size) || null, x: rows.find(r => r.axis === 'x') || null, y: rows.find(r => r.axis === 'y') || null, rows: rows.filter(r => !r.size && !r.axis), ...extra })
            const row = this.hoverRow || this.selectedRow || null   // IE 2026 09 16: узел под курсором, иначе выбранный кликом
            if (row) return split(this.nodeMeasures(row), { title: '', sub: '' })
            const sel = this.rectSel
            if (sel.length) return split(this.totalMeasures(sel), { title: this.tn(sel.length, '{n} node selected', '{n} nodes selected'), sub: this.t('totals') })   // IE 2026 09 23 / ODOO-341407: i18n
            return split(this.nodeMeasures(null), { title: '', sub: '', placeholder: true })
        },
        // ---- IE 2026 09 15 / ODOO-… (замечания Игоря): легенда и оси как у графика
        legendGrouped() { return this.attr?.['legend-grouped'] !== false },   // по умолчанию Grouped
        legendPopup() { return this.attr?.['legend-popup'] === true },
        // 'None' в записи — прежний дефолт («нет штатной легенды wijmo»): полоса классов при нём снизу, как и при Auto
        legendPos() { const v = String(this.attr?.['legend-position'] || 'Auto').toLowerCase(); return ['left', 'top', 'right', 'bottom'].includes(v) ? v : 'bottom' },
        // полоса классов: сторона по Legend position (Auto — снизу); нет — при Popup и при открытом окне легенды
        stripSide() {
            if (this.configError || this.legendPopup || this.levelsPanelVisible) return ''
            if (!(this.cfLevelTasks.length || this.levelsOn)) return ''
            return this.legendPos
        },
        // штатная легенда wijmo (имя серии) — только вне Grouped, как у графика
        wjLegendPosition() { if (this.legendGrouped) return 'None'; const p = String(this.attr?.['legend-position'] || 'None'); return p === 'Auto' ? 'Right' : (p === 'Popup' ? 'None' : p) },   // IE 2026 09 15: Popup — значение Legend position
        axisPositionX() { const p = String(this.attr?.['axisX-position'] || 'Auto'); return ['Top', 'Bottom'].includes(p) ? p : 'Auto' },
        axisPositionY() { const p = String(this.attr?.['axisY-position'] || 'Auto'); return ['Left', 'Right'].includes(p) ? p : 'Auto' },
        // Compact (по умолчанию включён): подписи делений и заголовок оси — внутри области, поля под ось не отнимаются
        compactX() { if (this.store?.mobileUi?.on) return false; const v = this.attr?.['compact-axisX']; return (v === undefined || v === null || v === '') ? true : !!v },
        compactY() { if (this.store?.mobileUi?.on) return false; const v = this.attr?.['compact-axisY']; return (v === undefined || v === null || v === '') ? true : !!v },
        xIsDateAxis() { return this.bindingX === '__x_idx' && this.xDetectDate() },   // IE 2026 09 16: индекс бывает и у категорий
        // IE 2026 09 15 (замечание Игоря): островок масштаба — в нижнем правом углу; подпись оси X — левее островка
        zoomIslandStyle() { return { bottom: (this.stripSide === 'bottom' ? this.levelsBox.h + 8 : 8) + 'px', right: (this.stripSide === 'right' ? this.levelsBox.w + 8 : 8) + 'px' } },
        axisTitleXStyle() { return { bottom: (this.stripSide === 'bottom' ? this.levelsBox.h + 6 : 6) + 'px', right: ((this.stripSide === 'right' ? this.levelsBox.w + 10 : 10) + (this.zoomBox.w ? this.zoomBox.w + 8 : 0)) + 'px' } },
        axisTitleYStyle() { return { top: (this.stripSide === 'top' ? this.levelsBox.h + 6 : 6) + 'px', left: (this.stripSide === 'left' ? this.levelsBox.w + 10 : 10) + 'px' } },
        // Отбор идёт через ШТАТНЫЙ селектор воркспейса. Два режима (bubble_select_mode):
        // 'pair' (дефолт) — набор id выбранных строк-правил уходит одним SEL типа
        //   selector_map_values: фильтр ТОЧНО по комбинациям товар×склад, без
        //   перемножения измерений (ODOO-4442);
        // 'dims' — по измерениям Set dimensions (fieldSelectors), как у гридов.
        isPairSelect() {
            return (this.attr?.bubble_select_mode || 'pair') !== 'dims'
        },
        canSelect() {
            if (this.isPairSelect) return true
            return !!(this.WIDGET?.record?.doc?.params?.fieldSelectors || []).length
        },
        // Группа общего отбора (bubble_pair_group): баблы одной группы делят ОДНУ
        // SEL-строку — отбор на любом из них дополняет общий список и подсвечивается
        // на остальных (Андрей 09.08: позиции с проблемами обеспечения в РАЗНЫХ
        // горизонтах собираются в один набор для анализа). Пусто = своя строка
        // на виджет, как раньше.
        pairGroup() {
            return this.attr?.bubble_pair_group || ''
        },
        // SEL парного отбора в WHERE воркспейса (живёт в сессии, в запись не оседает)
        pairSel() {
            const WORKSPACE = this.store.WORKSPACES?.[this.WIDGET?.workspace]
            const WHERE = WORKSPACE?.record?.doc?.params?.WHERE
            if (!Array.isArray(WHERE)) return null
            return WHERE.find(w => this.isMyPairSel(w)) || null
        },
        // ключи отобранных пар: значения измерений через '&' (id правил в выборке
        // нет — пара значений и есть идентификатор комбинации)
        pairIds() {
            const sel = this.pairSel
            if (!sel || sel.use === false) return new Set()
            const bindings = this.filterBindings()
            return new Set(((sel.attrs?.[0]?.attrs) || [])
                .filter(a => a?.use !== false)
                .map(a => {
                    const v = a?.rightValue?.value
                    return (v && typeof v === 'object') ? bindings.map(b => v[b]).join('&') : null
                }).filter(Boolean))
        },
        hasSelection() {
            if (this.isPairSelect) return this.pairIds.size > 0
            return !!this.WIDGET?.record?.doc?.params?.flex_havActiveSelectors
        },
        // ODOO-4443: уровни обеспеченности — классы точек по мере уровня
        // (дефолт — мера размера, у дистрибуции это DOS). Пороги в настройках;
        // палитра прошла проверку на дальтонизм (CVD ΔE 21+, контраст ≥3:1).
        levelBinding() {
            return this.attr?.bubble_level_binding || this.bindingSize
        },
        levelLow()  { return this.numOrNull(this.attr?.bubble_level_low) },
        levelHigh() { return this.numOrNull(this.attr?.bubble_level_high) },
        levelsOn()  { return !!this.levelBinding && (this.levelLow !== null || this.levelHigh !== null) },
        // ODOO-4440: счётчики точек по классам (независимы от скрытия классов)
        levelCounts() {
            const counts = {}
            if (!this.cfLevelTasks.length) return counts
            const [doc, binding] = this.store.attr_get_link(this.WIDGET, this.attr) || []
            for (const r of ((doc || {})[binding] || [])) {
                const t = this.matchedLevelTitle(r)
                if (t) counts[t] = (counts[t] || 0) + 1
            }
            return counts
        },
        // ODOO-5045: клик по метке нижней легенды гасит класс целиком.
        // Под опцией виджета — фронт общий, поведение чужих бабл-чартов не меняем.
        legendToggleOn() {
            return this.attr?.bubble_legend_toggle === true
        },
        // группы для попап-легенды (общее окно ChartLegendPanel): «серии» = классы
        // категорий с шариком цвета и счётчиком; тумблер прячет точки класса
        levelGroups() {
            const tasks = this.cfLevelTasks
            if (!tasks.length) return []
            const counts = this.levelCounts
            const series = tasks.map(t => {
                const title = t.title || '…'
                const label = t.label || title   // IE 2026 09 27 / ODOO-341407: подпись — на языке интерфейса, ключи (binding / visible / levelTitle) — базовый title
                return {
                    binding: `level::${title}`,
                    name: counts[title] ? `${label} (${counts[title]})` : label,   // IE 2026 09 27 / ODOO-341407
                    color: this.cfTaskColorOf(t),
                    visible: !this.hiddenLevels[title],
                    glyph: 'dot',
                    levelTitle: title,
                }
            })
            const visibleCount = series.filter(s => s.visible).length
            return [{ key: 'levels', title: '', series,
                      checked: visibleCount === series.length,
                      indeterminate: visibleCount > 0 && visibleCount < series.length,
                      collapsible: false, expanded: true }]
        },
        // задания условного оформления на мере уровня — из них строится легенда классов
        cfLevelTasks() {
            // АН 2026 08 15 / ODOO-4997: явный класс-канал (bubble_class_colors)
            // приоритетнее правил УО; титулы дедупим (Normal = ok+opt)
            if (this.classEntries().length) {
                const seen = new Set(); const out = []
                for (const e of this.classEntries()) {
                    const t = e.title || String(e.value)
                    if (seen.has(t)) continue
                    seen.add(t)
                    out.push({ title: t, label: this.classTitle(e), __classColor: e.color || '#4a90d9' })   // IE 2026 09 27 / ODOO-341407: title — ключ (база), label — подпись на языке интерфейса
                }
                return out
            }
            const rules = this.cfRules()
            const tasks = rules ? cfFieldTasks(rules, this.levelBinding) : []
            // cfFieldTasks отдаёт порядок применения (order по убыванию);
            // легенду показываем от критичного к спокойному — по возрастанию
            return tasks.slice().sort((a, b) => (+a.order || 0) - (+b.order || 0))
        },
    },
    methods: {
        // IE 2026 09 20 / ODOO-… (Игорь: легенда закрывается вместе с виджетом и на вкладке, к которой не относится): «своя» вкладка кроме холста — панель полей (⚙ легенды ведёт к полю уровня)
        legendOwner_flagOn() { return !!this.levelsPanelVisible },
        // IE 2026 09 27 / ODOO-341407: подписи из doc.viewParams.dataBubble (set_viewParams копирует в attr любые ключи, и суффиксные) —
        // вариант языка интерфейса {key}_{lang}, иначе база. Для языка по умолчанию — только база ({key}_en — резервная копия базы
        // в relocalize._set). getLanguage() реактивен (langVersion): computed / render пересчитываются при живом переключении языка.
        langVariant(obj, key) {
            const lang = getLanguage()
            const v = (obj && lang && lang !== LANGUAGE_DEFAULT) ? obj[`${key}_${lang}`] : null
            return (typeof v === 'string' && v) ? v : (obj?.[key] || '')
        },
        attrText(key) { return this.langVariant(this.attr, key) },   // IE 2026 09 27 / ODOO-341407
        // IE 2026 09 27 / ODOO-341407: ПОДПИСЬ класса bubble_class_colors (title_{lang}); КЛЮЧ класса (скрытие, счётчики, level::) — базовый e.title
        classTitle(e) { return this.langVariant(e, 'title') || String(e?.value) },
        legendOwner_close() { this.levelsPanelVisible = false },
        legendOwner_related() { return true },
        computeXAxisDates() {
            // АН 2026 08 15 / ODOO-4997: список подписей категориальной датной оси
            // (пересчёт в watcher'е rows — в computed side effect запрещён)
            if (!this.xDetectDate()) return null
            const [doc, binding] = this.store.attr_get_link(this.WIDGET, this.attr) || []
            const data = (doc || {})[binding] || []
            const bx = this.bindingXRaw
            const parse = (v) => {
                if (typeof v !== 'string' || !/^\d{4}-\d{2}(-\d{2})?/.test(v)) return null
                const d = new Date(v.length === 7 ? v + '-01' : v.slice(0, 10))
                return isNaN(d.getTime()) ? null : d.getTime()
            }
            const ds = [...new Set(data.map(r => r && parse(r[bx])).filter(t => t != null))].sort((a, z) => a - z)
            return ds.map((t, i) => {
                const d = new Date(t)
                return { value: i, text: d.toLocaleString(this.store.ui_locale(), { month: 'short' }), year: String(d.getFullYear()) }   // IE 2026 09 24 / ODOO-341407: подписи месяцев оси — локаль форматов (fe.i18n.formatsCulture), не en-US (обход dev02: Apr/Aug/… под uk)
            })
        },
        // IE 2026 09 16 (заказ Игоря: метрики пузырьками): категориальная ось — первое непустое значение поля не число и (для X) не дата
        catDetect(binding, skipDate) {
            const [doc, b] = this.store.attr_get_link(this.WIDGET, this.attr) || []
            const data = (doc || {})[b]
            if (!Array.isArray(data) || !binding) return false
            for (const r of data) {
                const v = r?.[binding]
                if (v == null || v === '') continue
                if (typeof v === 'number') return false
                const str = String(v)
                if (skipDate && /^\d{4}-\d{2}(-\d{2})?/.test(str)) return false
                return !Number.isFinite(+str)
            }
            return false
        },
        xDetectCat() { return !this.xDetectDate() && this.catDetect(this.bindingXRaw, true) },
        yDetectCat() { return this.catDetect(this.bindingYRaw, false) },
        // категории поля: порядок — по полю порядка (минимум по строкам), иначе по порядку появления; подпись — титул словаря / значение
        catList(binding, orderBinding) {
            const [doc, b] = this.store.attr_get_link(this.WIDGET, this.attr) || []
            const data = (doc || {})[b] || []
            const seen = new Map()
            for (const r of data) {
                if (!r) continue
                const v = r[binding]; if (v == null || v === '') continue
                const k = String(v)
                let e = seen.get(k)
                if (!e) { e = { key: k, text: this.valueTitle(r, binding) || k, order: Infinity, first: seen.size }; seen.set(k, e) }
                if (orderBinding) { const o = +r[orderBinding]; if (Number.isFinite(o) && o < e.order) e.order = o }
            }
            // подпись оси — не длиннее bubble_label_max (по умолчанию 36) с «…»; полный текст — в тегах наведения, плашке и легенде
            const maxLen = Math.max(8, +(this.attr?.bubble_label_max || 36))
            const cut = (t) => { const x = String(t); return x.length > maxLen ? x.slice(0, maxLen - 1).trimEnd() + '…' : x }
            return [...seen.values()].sort((a, z) => (a.order - z.order) || (a.first - z.first)).map((e, i) => ({ value: i, text: cut(e.text), full: e.text, key: e.key }))
        },
        // IE 2026 09 16: плотная категориальная ось Y (десятки строк матрицы) — кегль подписей по высоте строки: 11px … 7.5px
        catAxisFont() {
            const host = this.flex?.hostElement
            if (!host) return
            const n = this._yAxisCats ? this._yAxisCats.length : 0
            const h = host.clientHeight || 0
            const px = n && h ? Math.max(9, Math.min(11, (h * 0.86) / n * 0.82)) : 11   // не мельче 9px: лишние подписи прячет ось (Auto)
            host.style.setProperty('--bubble-ylabel', Math.round(px * 10) / 10 + 'px')
            host.classList.toggle('bubble-cat-y', !!n)
        },
        computeXAxisCats() { return this.xIsCatAxis ? this.catList(this.bindingXRaw, this.attr?.bubble_x_order) : null },
        computeYAxisCats() { return this.yIsCatAxis ? this.catList(this.bindingYRaw, this.attr?.bubble_y_order) : null },
        // ось Y по категориям: подписи из itemsSource, все подписи видны, границы ±0.5 (пузырьки крайних строк не режутся)
        applyCatAxisY() {
            const ay = this.flex?.axisY
            if (!ay) return
            if (this._yAxisCats) {
                ay.itemsSource = this._yAxisCats.map(it => ({ value: it.value, text: it.text }))
                ay.overlappingLabels = 0   // IE 2026 09 16 (замечание Игоря): при наложении подписи прячутся (Auto), строка узла — тегом по наведению
                if (this.numOrNull(this.attr?.['axisY-min']) == null) ay.min = -0.5
                if (this.numOrNull(this.attr?.['axisY-max']) == null) ay.max = this._yAxisCats.length - 0.5
            } else if (ay.itemsSource && !this._yAxisCatsWas) { /* ничего: не наша itemsSource */ }
            else if (this._yAxisCatsWas) { ay.itemsSource = null; ay.overlappingLabels = 0; ay.min = this.numOrNull(this.attr?.['axisY-min']); ay.max = this.numOrNull(this.attr?.['axisY-max']) }
            this._yAxisCatsWas = !!this._yAxisCats
            this.catAxisFont()
        },
        xDetectDate() {
            // ISO-строка в X ('2026-09' / '2026-09-01') → датный режим оси
            const [doc, binding] = this.store.attr_get_link(this.WIDGET, this.attr) || []
            const data = (doc || {})[binding]
            const bx = this.attr?.bubble_x || this.measures[0]?.binding || ''
            if (!Array.isArray(data) || !bx) return false
            for (const r of data) {
                const v = r?.[bx]
                if (v == null || v === '') continue
                return typeof v === 'string' && /^\d{4}-\d{2}(-\d{2})?/.test(v)
            }
            return false
        },
        measureTitle(binding) {
            if (!binding) return ''
            const m = this.fields.find(a => a.binding === binding)
            return m?.title || binding
        },
        // Подпись точки по ссылочному полю: витрина хранит id, названия в выборке нет.
        // Резолвер двухфазный (как в AttrTreeMap): вызов с ids ЗАПРАШИВАЕТ справочник,
        // а титулы в строки дописывает следующий вызов без ids — по приходу словаря.
        resolveLabels(mode = 'fetch') {
            // титулы нужны не только подписи (bubble_label), но и ПАРАМ отбора:
            // valueStr пары застывает в чипе воркспейса — нерезолвленный товар
            // оставался UUID в шапке (ODOO-4427, находка dm-data)
            const bindings = [...new Set([this.attr?.bubble_label, ...this.filterBindings()].filter(Boolean))]
            if (!bindings.length) return

            const [doc, binding] = this.store.attr_get_link(this.WIDGET, this.attr) || []
            const data = (doc || {})[binding]
            if (!Array.isArray(data) || !data.length) return

            for (const b of bindings) {
                const field = this.fields.find(f => f.binding === b)
                if (!field?.relation_segment) continue
                if (mode === 'fill') {
                    this.store.get_itemsSource(this, data, field, { fill: 'fill.title', fetchMode: 'justGet' })
                    continue
                }
                const ids = [...new Set(data
                    .map(row => this.store.get_value(row, b))
                    .filter(id => id && !String(id).startsWith('=') && !String(id).startsWith('#')))]
                if (ids.length) this.store.get_itemsSource(this, data, field, { fill: 'fill.title', ids })
            }
        },
        // Человеческое значение поля строки: титул из строки (его дописывает резолвер),
        // иначе — прямо из словаря сегмента: строки чарта копируются при подготовке,
        // и титул мог доехать позже копии.
        valueTitle(row, binding) {
            if (!binding || !row) return ''
            const filled = row[`${binding}.title`]
            if (filled) return filled
            const id = this.store.get_value(row, binding)
            const segment = this.fields.find(f => f.binding === binding)?.relation_segment
            return (segment && this.store.itemsSource[segment]?.ids?.[id]?.title) || id || ''
        },
        titleById(binding, id) {
            const segment = this.fields.find(f => f.binding === binding)?.relation_segment
            return (segment && this.store.itemsSource[segment]?.ids?.[id]?.title) || ''
        },
        // ODOO-4427: «Отобрать» раньше словаря замораживал в valueStr сырой UUID
        // (гонка: подпись пары пишется один раз). По приходу справочника дописываем
        // подписи в SEL-строке — чинит и застывшие чипы прошлых отборов
        refreshPairLabels() {
            const sel = this.pairSel
            if (!sel) return
            const bindings = this.filterBindings()
            const uuidRe = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i
            for (const a of (sel.attrs?.[0]?.attrs || [])) {
                const v = a?.rightValue?.value
                if (!v || typeof v !== 'object') continue
                const cur = String(a.rightValue.valueStr || '')
                if (cur && !uuidRe.test(cur)) continue
                const parts = bindings.map(b => this.titleById(b, v[b]) || v[b]).filter(Boolean)
                const label = parts.join(' × ')
                if (label && label !== cur) a.rightValue.valueStr = label
            }
        },
        rowLabel(row) {
            return this.valueTitle(row, this.attr?.bubble_label)
        },
        content_Changed() {
            this.store.widget_attr_set(this)
        },
        mobilePlotMargin(flex, axesOn = false) {
            if (!this.store.mobileUi?.on || !flex) return
            try {
                flex.plotMargin = axesOn ? NaN : '6 6 6 6'
                flex.invalidate?.()
            } catch (e) { /* тип чарта без plotMargin */ }
        },
        initializeChart(flex) {
            // IE 2026 08 20 / ODOO-336291 (mobile UX) (#4195): на телефоне подписи осей скрыты — не резервировать под них поля,
            // график заполняет виджет; тумблер осей возвращает авто-отступы (mobileChartAxes)
            this.mobilePlotMargin(flex)
            this.flex = flex
            this.applyOptions()
            // данные могли приехать раньше чарта — подписи оси пересчитать тут же
            this._xAxisDates = this.computeXAxisDates(); this._xAxisCats = this.computeXAxisCats(); this._yAxisCats = this.computeYAxisCats()   // IE 2026 09 16: и категории
            if (this.selectedRow) { const src = this.selectedRow.__src; this.selectedRow = this.rows.find(r => r.__src === src) || null }   // IE 2026 09 16: выбранный узел — к новым строкам
            this.applyDateAxis(); this.applyCatAxisY()
            // IE 2026 09 15 (замечание Игоря): Compact — подписи делений переносятся внутрь области после каждой отрисовки
            flex.rendered.addHandler(() => this.compactLabels())
            flex.rendered.addHandler(() => this.axisFit())   // IE 2026 09 27 / ODOO-341407: подписи осей — мимо шапки и островка масштаба, без слипания
            this.compactApply()
            // IE 2026 09 15 (замечание Игоря, вечер): запись сохранена с Legend position = Popup — полоса классов скрыта, значит окно легенды
            // открывается сразу (иначе у пузырьков нет легенды вовсе, пока не нажать кнопку)
            // IE 2026 09 16 (замечание Игоря): при открытии виджета окно легенды НЕ показывать, даже если в записи Legend position = Popup —
            // окно открывается кнопкой легенды (островок) или выбором Popup в быстрых настройках (прежнее автооткрытие fe-2026-09-15-39 снято)
            // IE 2026 09 15 (замечание Игоря, вечер): плашка узла — по наведению (клик прикалывает), подписи значений X / Y на осях
            const host = flex.hostElement
            if (host && !host._bubbleHover) {
                host._bubbleHover = true
                host.addEventListener('mousemove', this.chart_onMouseMove, { passive: true })
                host.addEventListener('mouseleave', this.chart_onMouseLeave, { passive: true })
                host.addEventListener('contextmenu', this.bubbleSel_onContextMenu)   // IE 2026 10 13 / ODOO-5800: правая кнопка по пузырю — прежняя плашка, когда клик ставит селекторы
                host.addEventListener('pointerdown', this.rect_onDown, true)   // IE 2026 09 16: Shift + протяжка — прямоугольник выбора; pointerdown — жесты wijmo гасят compat-mousedown
                // U6 (заказ Игоря: объяснение элементов по Alt): пузырёк рисует wijmo (постоянного DOM-узла на точку нет) — источник altTooltip «по точке»
                // на корне SVG графика (uiHelp6_bindPoint); вне пузырьков — прежнее объяснение области (v-uiHelp chart.bubble.plot на хосте)
                this.uiHelp6_bindPoint(); flex.rendered.addHandler(() => this.uiHelp6_bindPoint())
            }
            this.$nextTick(() => this.attrResize())
        },
        // IE 2026 09 15 (замечание Игоря): поля области графика в компактном режиме — минимальные (подписи внутри, заголовок оси —
        // своей подписью внутри); датная ось X (ярус годов рисуется снаружи) остаётся с авто-полем
        compactApply() {
            const flex = this.flex
            if (!flex || this.store?.mobileUi?.on) return
            const cx = this.compactX && !this.xIsDateAxis, cy = this.compactY
            const right = this.axisPositionY === 'Right', top = this.axisPositionX === 'Top'
            const m = { top: (cx && top) ? 10 : ((cy || cx) ? 10 : 'NaN'), right: (cy && right) ? 12 : 'NaN', bottom: (cx && !top) ? 10 : 'NaN', left: (cy && !right) ? 12 : 'NaN' }
            if (!cy) { m.left = 'NaN'; m.right = 'NaN' }
            // IE 2026 09 27 / ODOO-341407: без Compact — правое поле оставляет угол островку масштаба (zoomReserveFit); условия не те — поле снова авто
            if (!this.zoomReserveOn()) this._zoomReserve = null
            else if (this._zoomReserve && this._zoomReserve.r > 0) m.right = this._zoomReserve.r
            // IE 2026 09 28 / ODOO-341407: верх области — ниже островков парящей шапки (headerReserveFit); выше авто / Compact-поля не поднимает
            if (!this.headerReserveOn()) this._hdrReserve = null
            else if (this._hdrReserve && this._hdrReserve.t > 0 && (m.top === 'NaN' || this._hdrReserve.t > +m.top)) m.top = this._hdrReserve.t
            flex.plotMargin = `${m.top} ${m.right} ${m.bottom} ${m.left}`
            flex.invalidate()
        },
        compactLabels() {
            const flex = this.flex, host = flex?.hostElement, pr = flex?._plotRect || flex?.plotRect
            if (!host || !pr || this.store?.mobileUi?.on) return
            if (this.compactY) {
                for (const t of host.querySelectorAll('.wj-axis-y text')) {
                    const x = parseFloat(t.getAttribute('x')); if (!Number.isFinite(x)) continue
                    if (x <= pr.left + 1) { t.setAttribute('x', String(pr.left + 4)); t.setAttribute('text-anchor', 'start'); t.style.textAnchor = 'start'; t.classList.add('bubble-axis-inside') }
                    else if (x >= pr.right - 1) { t.setAttribute('x', String(pr.right - 4)); t.setAttribute('text-anchor', 'end'); t.style.textAnchor = 'end'; t.classList.add('bubble-axis-inside') }
                }
            }
            if (this.compactX && !this.xIsDateAxis) {
                for (const t of host.querySelectorAll('.wj-axis-x text')) {
                    const y = parseFloat(t.getAttribute('y')); if (!Number.isFinite(y)) continue
                    if (y >= pr.bottom - 1) { t.setAttribute('y', String(pr.bottom - 5)); t.classList.add('bubble-axis-inside') }
                    else if (y <= pr.top + 1) { t.setAttribute('y', String(pr.top + 13)); t.classList.add('bubble-axis-inside') }
                }
            }
        },
        // ---- IE 2026 09 27 / ODOO-341407 (замечания ie-dm7 #47471 по живой проверке FADO; длинные uk-подписи {key}_{lang}): подписи осей не заходят
        // под островки. Заголовок оси Y (SVG wijmo, без Compact) — не под островками шапки в Float (бейдж «Джерело», поле заголовка — те, что над ним по
        // горизонтали) и в пределах виджета; заголовок оси X — левее островка масштаба; не влез — «…», полный текст в подсказке (svgTitleTip: по Alt /
        // в режиме Show tooltips). Подписи оси X: без Compact правое поле области оставляет угол островку масштаба
        // (zoomReserveFit), под островком не остаётся ни одной (Compact — прячутся), соседние ближе 5px не слипаются — прячется менее «круглая» (у
        // лог-оси остаются степени основания). Помещается — ничего не меняется. Выкл: window.feSettings.set('fe.ux.bubbleAxisFit', false) — как было
        axisFitOn() { try { return this.store.setting('fe.ux.bubbleAxisFit', true) !== false } catch (e) { return true } },
        // IE 2026 09 27 / ODOO-341407: поле под островок масштаба: без Compact по X, ось X снизу, ось Y не справа (там поле занято её подписями), островок включён
        zoomReserveOn() {
            return !!(this.flex && this.axisFitOn() && !this.store?.mobileUi?.on && this.attr?.['bubble_gestures'] !== false
                && !(this.compactX && !this.xIsDateAxis) && this.axisPositionX !== 'Top' && this.axisPositionY !== 'Right')
        },
        axisFit() {
            const flex = this.flex, host = flex?.hostElement, pr = flex?._plotRect || flex?.plotRect
            if (!host || !pr || !pr.width || this.store?.mobileUi?.on) return
            const fitOn = this.axisFitOn()   // IE 2026 09 28 / ODOO-341407: подгонка подписей и верх области под шапкой — каждая под своим флагом
            if (!fitOn && !this.headerReserveOn() && !this._hdrReserve) return   // IE 2026 09 28 / ODOO-341407
            try {
                const svg = host.querySelector('svg')   // начало координат — SVG wijmo (в них _plotRect и axis.convert), не рамка хоста
                const hb = (svg || host).getBoundingClientRect()
                if (!hb.width || !hb.height) return
                if (fitOn) {   // IE 2026 09 28 / ODOO-341407: fe.ux.bubbleAxisFit — как было
                    const rel = (el) => { const r = el.getBoundingClientRect(); return { left: r.left - hb.left, right: r.right - hb.left, top: r.top - hb.top, bottom: r.bottom - hb.top } }
                    const zi = this.$refs.zoomIsland
                    const zr = (zi && zi.offsetWidth) ? rel(zi) : null
                    this.zoomReserveFit(host, hb, pr, zr)
                    this.labelsFitX(host, hb, zr)
                    this.axisTitlesFit(host, hb, zr, rel)
                }
                this.headerReserveFit(host, hb, pr)   // IE 2026 09 28 / ODOO-341407: fe.ux.bubbleHeaderReserve
            } catch (e) { /* подгонка подписей — best effort, отрисовку не роняет */ }
        },
        // ---- IE 2026 09 28 / ODOO-341407 (замечание ie-fado7 по проду FADO на 1366, bubble_layout_check_0928 п. 2: ieXYZB_005 — верхняя подпись оси Y «X» наполовину
        // под бейджем «Джерело», пузыри ряда X под островком заголовка). В Float со скрытыми табами шапка лежит поверх холста (6b3924f20, 14.09), а верх области
        // графика — авто wijmo (~14px от верха виджета): в высоком виджете верхний ряд и так ниже островков шапки, в низком (342px, длинные наклонные подписи оси X
        // забирают высоту) — под ними; так было и на -18 (правки -19…-25 область не двигали). Теперь верх области опускается ровно настолько, чтобы верхние подписи
        // оси Y и пузыри, которые по горизонтали под островком шапки (бейдж, поле заголовка, меню ≡, островок 🏷 ⚙ в строке шапки), были ниже него на 4px;
        // прозрачные промежутки шапки не в счёт (график под ними виден, как задумано). Нужный верх — headerReserveTop (линейно по верху области → без качелей),
        // не ниже половины области. Выкл: window.feSettings.set('fe.ux.bubbleHeaderReserve', false) — верх области авто, как было
        headerReserveOn() { try { return this.store.setting('fe.ux.bubbleHeaderReserve', true) !== false } catch (e) { return true } },
        // островки шапки поверх холста в координатах SVG: видимые дети шапки в её полосе (всплывающие панели — fixed / ниже полосы — не в счёт, невидимая полоса
        // tabs-hover-zone — тоже) и островок кнопок холста, если он в строке шапки (вкладка визуализации); шапка отдельной строкой / скрыта — []
        headerIslands(hb) {
            const W = this.$refs.attr_container?.closest?.('.WIDGET')
            if (!W || !W.classList.contains('widget-float-header') || !W.classList.contains('widget-hide-tabs') || W.classList.contains('widget-hide-header')) return []
            const head = W.querySelector(':scope > .widget-container')
            if (!head || !head.offsetHeight) return []
            const hr = head.getBoundingClientRect()
            const out = []
            const add = (el) => {
                if (!el || !el.offsetWidth || !el.offsetHeight || el.classList.contains('tabs-hover-zone')) return
                const r = el.getBoundingClientRect()
                if (r.top < hr.top - 2 || r.bottom > hr.bottom + 2) return
                out.push({ l: r.left - hb.left, r: r.right - hb.left, b: r.bottom - hb.top })
            }
            for (const el of head.children) add(el)
            const isl = this.$refs.attr_container?.querySelector(':scope > .corner-island-tr')
            if (isl && isl.offsetWidth && isl.getBoundingClientRect().top < hr.bottom) { const r = isl.getBoundingClientRect(); out.push({ l: r.left - hb.left, r: r.right - hb.left, b: r.bottom - hb.top }) }
            return out
        },
        headerReserveFit(host, hb, pr) {
            const on = this.headerReserveOn()
            const islands = on ? this.headerIslands(hb) : []
            if (!this._hdrReserve) this._hdrAutoTop = pr.top   // поле авто (или Compact) — его верх: ниже него верх области не опускаем без нужды, выше — не поднимаем
            let top = null
            if (islands.length) {
                const items = []
                const push = (r) => { if (r.width || r.height) items.push({ l: r.left - hb.left, r: r.right - hb.left, top: r.top - hb.top, anchor: (r.top + r.bottom) / 2 - hb.top }) }
                // подписи оси Y (заголовок оси — своя подгонка axisTitlesFit) и оси X, если она сверху; пузыри серии (кружки легенды wijmo — не в счёт)
                for (const t of host.querySelectorAll('.wj-axis-y text, .wj-axis-x text')) {
                    if (/\bwj-title\b/.test(t.getAttribute('class') || '') || t.getAttribute('visibility') === 'hidden') continue
                    if (this.axisPositionX !== 'Top' && t.closest('.wj-axis-x')) continue
                    push(t.getBoundingClientRect())
                }
                for (const e of host.querySelectorAll('ellipse')) { if (!e.closest('.wj-legend')) push(e.getBoundingClientRect()) }
                top = headerReserveTop({ plotTop: pr.top, plotBottom: pr.top + pr.height, autoTop: this._hdrAutoTop, items, islands, gap: 4 })
            }
            const st = this._hdrReserve
            if (top == null) { if (st) { this._hdrReserve = null; this.compactApply() } return }
            if (st && Math.abs(st.t - top) < 1) return
            // не больше 4 перестановок на размер хоста и раскладку шапки (страховка от качелей у числовой оси, где wijmo подбирает деления по высоте)
            const sig = `${Math.round(hb.width)}x${Math.round(hb.height)}|` + islands.map(i => `${Math.round(i.l)},${Math.round(i.r)},${Math.round(i.b)}`).join(';')
            const n = st && st.sig === sig ? st.n : 0
            if (n >= 4) return
            this._hdrReserve = { t: top, sig, n: n + 1 }
            this.compactApply()
        },
        // IE 2026 09 27 / ODOO-341407: без Compact подписи оси X лежат под областью графика, островок масштаба (нижний правый угол) накрывал крайние справа. Правое поле области —
        // такое, чтобы правый край каждой подписи в полосе островка был левее него на 6px: подпись в доле f ширины области сдвигается при сужении на f·Δ.
        // Поле только растёт (подписи могут смениться при сужении — без качелей), не больше 4 шагов на ширину хоста; дальше подписи под островком прячутся
        zoomReserveFit(host, hb, pr, zr) {
            if (!zr || !this.zoomReserveOn()) { if (this._zoomReserve) { this._zoomReserve = null; this.compactApply() } return }
            const L = zr.left - 6
            let pwMax = Infinity
            for (const t of host.querySelectorAll('.wj-axis-x text')) {
                if (/\bwj-title\b/.test(t.getAttribute('class') || '')) continue
                const g = t.parentNode
                if (/rotate/.test((t.getAttribute('transform') || '') + ' ' + ((g && g.getAttribute && g.getAttribute('transform')) || ''))) continue
                const r = t.getBoundingClientRect(); if (!r.width) continue
                if (r.bottom - hb.top < zr.top - 2 || r.top - hb.top > zr.bottom + 2) continue   // не в полосе островка
                const f = ((r.left + r.right) / 2 - hb.left - pr.left) / pr.width
                if (!(f > 0.25)) continue
                pwMax = Math.min(pwMax, (L - r.width / 2 - pr.left) / f)
            }
            if (!Number.isFinite(pwMax)) return
            // IE 2026 09 27 / ODOO-341407: не больше половины ширины справа от оси Y: в совсем узком виджете область не схлопывается — подписи под островком просто прячутся
            const need = Math.min(Math.ceil(hb.width - pr.left - pwMax), Math.floor((hb.width - pr.left) / 2)), now = hb.width - pr.left - pr.width   // IE 2026 09 27 / ODOO-341407
            if (need <= now + 1) return
            const w = Math.round(hb.width), st = this._zoomReserve
            const n = st && st.w === w ? st.n : 0
            if (n >= 4) return
            this._zoomReserve = { r: need, w, n: n + 1 }
            this.compactApply()
        },
        // IE 2026 09 27 / ODOO-341407: подписи оси X: под островком масштаба — прячутся; соседние ближе 5px — прячется одна: у лог-оси остаётся степень основания, иначе — левая
        labelsFitX(host, hb, zr) {
            const items = []
            for (const t of host.querySelectorAll('.wj-axis-x text')) {
                if (/\bwj-title\b/.test(t.getAttribute('class') || '') || t.getAttribute('visibility') === 'hidden') continue
                const r = t.getBoundingClientRect(); if (!r.width) continue
                const o = { t, l: r.left - hb.left, r: r.right - hb.left, top: r.top - hb.top, b: r.bottom - hb.top }
                if (zr && o.l < zr.right + 2 && o.r > zr.left - 2 && o.top < zr.bottom + 2 && o.b > zr.top - 2) { t.setAttribute('visibility', 'hidden'); continue }
                const g = t.parentNode
                if (/rotate/.test((t.getAttribute('transform') || '') + ' ' + ((g && g.getAttribute && g.getAttribute('transform')) || ''))) continue   // наклонные — своя раскладка wijmo
                o.cx = (o.l + o.r) / 2
                items.push(o)
            }
            if (items.length < 2) return
            items.sort((a, z) => a.l - z.l)
            const pow = []
            const base = +this.attr?.['axisX-logBase'] || 0
            const ax = this.flex?.axisX
            if (base > 1 && ax) {
                const lo = +ax.actualMin, hi = +ax.actualMax
                if (lo > 0 && hi > lo) {
                    const k0 = Math.floor(Math.log(lo) / Math.log(base)), k1 = Math.ceil(Math.log(hi) / Math.log(base))
                    for (let k = k0; k <= k1 && k - k0 < 60; k++) { const px = ax.convert(Math.pow(base, k)); if (Number.isFinite(px)) pow.push(px) }
                }
            }
            const isPow = (o) => pow.some(p => Math.abs(p - o.cx) <= 2)
            const kept = []
            for (const o of items) {
                let cur = o
                while (cur && kept.length && cur.l - kept[kept.length - 1].r < 5) {
                    const prev = kept[kept.length - 1]
                    if (isPow(cur) && !isPow(prev)) { prev.t.setAttribute('visibility', 'hidden'); kept.pop() }
                    else { cur.t.setAttribute('visibility', 'hidden'); cur = null }
                }
                if (cur) kept.push(cur)
            }
        },
        // IE 2026 09 27 / ODOO-341407: заголовки осей (SVG wijmo — только без Compact): Y — ниже островков шапки над содержимым (Float), которые над ним по горизонтали, и островка кнопок,
        // выше островка масштаба, в пределах хоста; X — левее островка масштаба, если он в полосе заголовка
        axisTitlesFit(host, hb, zr, rel) {
            const yEl = !this.compactY && host.querySelector('.wj-axis-y .wj-title')
            if (yEl) {
                const r = yEl.getBoundingClientRect(), x0 = r.left - hb.left, x1 = r.right - hb.left
                let lo = 2, hi = hb.height - 2
                const over = this.headerOverBottom(hb, x0, x1)   // IE 2026 09 27 / ODOO-341407: только островки над заголовком оси
                if (over !== null) lo = Math.max(lo, over + 4)
                const isl = this.$refs.attr_container?.querySelector(':scope > .corner-island-tr')
                if (isl && isl.offsetWidth) { const ir = rel(isl); if (ir.left < x1 + 4 && ir.right > x0 - 4 && ir.top < hb.height / 2) lo = Math.max(lo, ir.bottom + 4) }
                if (zr && zr.left < x1 + 4 && zr.right > x0 - 4) hi = Math.min(hi, zr.top - 4)
                this.fitSvgTitle(yEl, 'y', lo, hi, this.titleY, hb)
            }
            const xEl = !(this.compactX && !this.xIsDateAxis) && host.querySelector('.wj-axis-x .wj-title')
            if (xEl) {
                const r = xEl.getBoundingClientRect(), y0 = r.top - hb.top, y1 = r.bottom - hb.top
                let hi = hb.width - 2
                if (zr && zr.top < y1 + 2 && zr.bottom > y0 - 2) hi = Math.min(hi, zr.left - 6)
                this.fitSvgTitle(xEl, 'x', 2, hi, this.titleX, hb)
            }
        },
        // IE 2026 09 27 / ODOO-341407: нижний край островков шапки, лежащей поверх содержимого (Float со скрытыми табами), которые по горизонтали накрывают [x0, x1] — бейдж
        // «Джерело», поле заголовка, меню и угол ⋯ (зона наведения .resizer-top-left открывает форму ⋯ — заголовок оси под ней не держим; невидимая полоса
        // табов tabs-hover-zone — не в счёт); координаты SVG; шапка отдельной строкой / не накрывают — null
        headerOverBottom(hb, x0, x1) {
            const W = this.$refs.attr_container?.closest?.('.WIDGET')
            if (!W || !W.classList.contains('widget-float-header') || !W.classList.contains('widget-hide-tabs') || W.classList.contains('widget-hide-header')) return null
            const head = W.querySelector(':scope > .widget-container')
            if (!head) return null
            let bottom = null
            for (const el of [...head.children, W.querySelector(':scope > .resizer-top-left')].filter(Boolean)) {   // IE 2026 09 27 / ODOO-341407: и угол ⋯
                if (el.classList.contains('tabs-hover-zone') || !el.offsetWidth || !el.offsetHeight) continue
                const r = el.getBoundingClientRect()
                if (r.right - hb.left < x0 - 4 || r.left - hb.left > x1 + 4 || r.top - hb.top > hb.height / 2) continue
                bottom = Math.max(bottom === null ? -Infinity : bottom, r.bottom - hb.top)
            }
            return bottom
        },
        // IE 2026 09 27 / ODOO-341407: полный текст урезанного заголовка оси — по правилу подсказок платформы (utils/nativeTitles: только по Alt или в режиме Show tooltips):
        // __nativeTitle + aria-label + пометка data-native-title; правило выключено (fe.ux.nativeTitles / fe.ux.hoverTooltips) — нативная <title> SVG
        svgTitleTip(el, text) {
            let gated = false
            try { gated = nativeTitles.enabled() } catch (e) { gated = false }   // IE 2026 09 27 / ODOO-341407
            el.setAttribute('aria-label', text)
            if (gated) { el.__nativeTitle = text; el.setAttribute('data-native-title', ''); return }
            const tip = document.createElementNS('http://www.w3.org/2000/svg', 'title')
            tip.textContent = text
            el.appendChild(tip)
        },
        // IE 2026 09 27 / ODOO-341407: заголовок оси в промежуток [lo, hi] вдоль своей оси (y — повёрнутый заголовок оси Y, x — оси X): помещается — без изменений; длиннее промежутка —
        // «…» по длине, полный текст в подсказке (svgTitleTip), по центру промежутка; короче — минимальный сдвиг внутрь. Сдвиг — translate у повёрнутой группы
        // wijmo (<g rotate>) или у самого текста, в осях экрана
        fitSvgTitle(el, axis, lo, hi, full, hb) {
            if (!el || !(hi - lo > 24)) return
            const box = () => { const r = el.getBoundingClientRect(); return axis === 'y' ? [r.top - hb.top, r.bottom - hb.top] : [r.left - hb.left, r.right - hb.left] }
            let [a, b] = box()
            if (!(b > a) || (a >= lo - 0.5 && b <= hi + 0.5)) return
            const text = String(full || el.textContent || '')
            let cut = false
            if (b - a > hi - lo && text.length > 2) {
                const room = hi - lo - 2
                let l = 1, h = text.length - 1
                while (l < h) {
                    const m = (l + h + 1) >> 1
                    el.textContent = text.slice(0, m).trimEnd() + '…'
                    if (el.getComputedTextLength() <= room) l = m; else h = m - 1
                }
                el.textContent = text.slice(0, l).trimEnd() + '…'
                this.svgTitleTip(el, text)   // IE 2026 09 27 / ODOO-341407: полный текст — по правилу подсказок (Alt / Show tooltips)
                cut = true
                const bb = box()
                a = bb[0]; b = bb[1]
            }
            const d = cut ? (lo + hi) / 2 - (a + b) / 2 : (a < lo ? lo - a : hi - b)
            if (Math.abs(d) < 0.5) return
            const g = el.parentNode
            const tgt = (g && g.tagName && g.tagName.toLowerCase() === 'g' && /rotate/.test(g.getAttribute('transform') || '')) ? g : el
            const tr = tgt.getAttribute('transform') || ''
            tgt.setAttribute('transform', (axis === 'y' ? `translate(0 ${d.toFixed(1)})` : `translate(${d.toFixed(1)} 0)`) + (tr ? ' ' + tr : ''))
        },
        // IE 2026 09 15 (замечание Игоря): кнопки масштаба островка — шаг по осям жестов (scale — доля видимого диапазона, pos — начало),
        // центр вида сохраняется; оси — по настройке Wheel zoom (X / Y / обе)
        zoomBy(dir) {
            const g = this.gestures
            if (!g) return
            const k = dir > 0 ? 0.7 : 1 / 0.7
            const axes = String(this.attr?.bubble_axes || 'XY')
            const apply = (sKey, pKey) => {
                const s = Number.isFinite(g[sKey]) ? g[sKey] : 1, p = Number.isFinite(g[pKey]) ? g[pKey] : 0
                const ns = Math.max(0.02, Math.min(1, s * k))
                g[pKey] = Math.max(0, Math.min(1 - ns, p + (s - ns) / 2))
                g[sKey] = ns
            }
            if (axes.includes('X')) apply('scaleX', 'posX')
            if (axes.includes('Y')) apply('scaleY', 'posY')
            this.flex?.invalidate()
        },
        applyDateAxis() {
            // АН 2026 08 15 / ODOO-4997: ярусные подписи датной оси как в Chart —
            // месяцы штатными подписями, ярус ГОДОВ рисуем сами в rendered
            // (drawYearTier): wijmo AxisGroups позиционирует группы по индексу
            // строки CollectionView, а у баблов много точек на одну дату —
            // подписи годов улетали за правый край (x≈1050 при ширине 823)
            const ax = this.flex?.axisX
            if (!ax) return
            // IE 2026 09 16 (заказ Игоря: метрики пузырьками): категориальная ось X — подписи категорий, границы ±0.5, заголовок остаётся
            if (this._xAxisCats && !this._xAxisDates) {
                ax.itemsSource = this._xAxisCats.map(it => ({ value: it.value, text: it.text }))
                ax.overlappingLabels = 1
                if (this.numOrNull(this.attr?.['axisX-min']) == null) ax.min = -0.5
                if (this.numOrNull(this.attr?.['axisX-max']) == null) ax.max = this._xAxisCats.length - 0.5
                this._xAxisCatsWas = true
                return
            }
            if (this._xAxisCatsWas) { this._xAxisCatsWas = false; ax.itemsSource = null; ax.overlappingLabels = 0; ax.min = this.numOrNull(this.attr?.['axisX-min']); ax.max = this.numOrNull(this.attr?.['axisX-max']) }
            if (this._xAxisDates) {
                ax.itemsSource = this._xAxisDates.map(it => ({ value: it.value, text: it.text }))
                // заголовок оси ('Month') налезает на ярус годов — в датном
                // режиме прячем, даты говорят сами за себя (как в Chart)
                if (ax.title) { this._xAxisTitle = ax.title; ax.title = '' }
                if (!this._yearTierHooked) {
                    this._yearTierHooked = true
                    this.flex.rendered.addHandler((s, a) => this.drawYearTier(a?.engine))
                }
            } else if (ax.itemsSource) {
                ax.itemsSource = null
                if (this._xAxisTitle) { ax.title = this._xAxisTitle; this._xAxisTitle = null }
            }
        },
        drawYearTier(engine) {
            // АН 2026 08 15 / ODOO-4997 (замечание Игоря п.3): второй ярус оси —
            // ГОДЫ, центрированные под своими месяцами, с разделителями границ
            const ds = this._xAxisDates
            const ax = this.flex?.axisX
            const pr = this.flex?._plotRect || this.flex?.plotRect
            if (!engine || !ds || !ds.length || !ax || !pr || !pr.width) return
            const groups = []
            for (const it of ds) {
                let g = groups[groups.length - 1]
                if (!g || g.year !== it.year) { g = { year: it.year, from: it.value, to: it.value }; groups.push(g) }
                g.to = it.value
            }
            const yLab = pr.top + pr.height + 32
            const yT1 = pr.top + pr.height + 20, yT2 = yLab + 2
            const tick = { stroke: '#bbb', 'stroke-width': 1 }
            for (const g of groups) {
                const x1 = ax.convert(g.from - 0.5), x2 = ax.convert(g.to + 0.5)
                engine.drawString(g.year, new Point((x1 + x2) / 2 - 13, yLab), null, { fill: '#666', 'font-size': '11px' })
                engine.drawLine(x1, yT1, x1, yT2, null, tick)
            }
            const xEnd = ax.convert(groups[groups.length - 1].to + 0.5)
            engine.drawLine(xEnd, yT1, xEnd, yT2, null, tick)
        },
        initializeGestures(gestures) {
            this.gestures = gestures
        },
        resetZoom() {
            // IE 2026 09 15 (замечание Игоря): сброс и после масштаба кнопками островка — wijmo reset() помнит исходный диапазон только
            // после жеста мышью; доля / начало осей жестов — на всю шкалу, границы осей — из настроек (пусто = авто)
            const g = this.gestures
            try { g?.reset() } catch (e) { /* без жестов */ }
            if (g) { g.scaleX = 1; g.scaleY = 1; g.posX = 0; g.posY = 0 }
            const ax = this.flex?.axisX, ay = this.flex?.axisY
            if (ax) { ax.min = this.numOrNull(this.attr?.['axisX-min']) ?? (this._xAxisCats ? -0.5 : null); ax.max = this.numOrNull(this.attr?.['axisX-max']) ?? (this._xAxisCats ? this._xAxisCats.length - 0.5 : null) }   // IE 2026 09 16: категории ±0.5
            if (ay) { ay.min = this.numOrNull(this.attr?.['axisY-min']) ?? (this._yAxisCats ? -0.5 : null); ay.max = this.numOrNull(this.attr?.['axisY-max']) ?? (this._yAxisCats ? this._yAxisCats.length - 0.5 : null) }
            this.flex?.invalidate()
        },
        // Правила условного оформления (Игоря) для меры уровня: бэк отдаёт
        // cf_rules на узле листа данных — читаем их же, движок общий (cfEval).
        cfRules() {
            // АН 2026 08 15 / ODOO-4997: диагностика источника классов (__simDebug)
            const _dbg = (res) => {
                if (window.__simDebug) console.log('sim: bubble cfRules', res ? 'found' : 'MISSING',
                    res ? Object.keys(res.fields || {}).join(',') : '', 'level binding', this.levelBinding)
                return res
            }
            const find = (items) => {
                for (const a of items || []) {
                    if (a?.cf_rules) return a.cf_rules
                    const r = a?.attrs && find(a.attrs)
                    if (r) return r
                }
                return null
            }
            return _dbg(find(this.WIDGET?.view))
        },
        // Класс обеспеченности точки. Приоритет: правило условного оформления
        // на мере уровня (движок Игоря) → пороги bubble_level_low/high.
        // null = ничего не настроено, точка остаётся в цвете серии.
        // АН 2026 08 15 / ODOO-4997: нативный канал классов по строковому полю —
        // bubble_class_binding (напр. category) + bubble_class_colors
        // ([{value,title,color}]); работает без правил условного оформления
        classEntries() {
            const raw = this.attr?.bubble_class_colors
            return Array.isArray(raw) ? raw.filter(e => e && e.value !== undefined) : []
        },
        classEntryOf(row) {
            const binding = this.attr?.bubble_class_binding
            if (!binding || !this.classEntries().length || !row) return null
            const src = row.__src || row
            const v = String(this.store.get_value(src, binding) ?? '')
            return this.classEntries().find(e => String(e.value) === v) || null
        },
        levelColor(row) {
            if (!row) return null
            const ce = this.classEntryOf(row)
            if (ce) return ce.color || '#4a90d9'
            const rules = this.cfRules()
            const tasks = rules ? cfFieldTasks(rules, this.levelBinding) : []
            if (tasks.length) {
                const src = row.__src || row
                const ctx = { getValue: (o, b) => this.store.get_value(o, b) }
                let color = null
                // как в гриде: последний применённый побеждает
                for (const task of tasks) {
                    if (cfCheckWHERE(task, src, this.levelBinding, null, ctx)) {
                        color = cfTaskColor(task, { vivid: true }) || color
                    }
                }
                if (color) return color
            }
            if (!this.levelsOn) return null
            const v = +row[this.levelBinding]
            if (!Number.isFinite(v)) return null
            if (this.levelLow !== null && v < this.levelLow) {
                return this.attr?.bubble_level_lowColor || '#c9302c'    // дефицит
            }
            if (this.levelHigh !== null && v > this.levelHigh) {
                return this.attr?.bubble_level_highColor || '#b98514'   // избыток
            }
            return this.attr?.bubble_level_midColor || '#4a90d9'        // норма
        },
        // Отобранная позиция выделяется цветом: wijmo рисует все пузырьки палитрой
        // серии, поэтому подменяем заливку/обводку перед штатной отрисовкой.
        // Приоритет: отбор (оранжевый/приглушение) поверх класса уровня.
        // Признак отбора — штатный флаг row.selector (его же ставит чекбокс листа
        // данных, а бэкенд восстанавливает при каждой выборке из селекторов воркспейса).
        itemFormatter(engine, ht, defaultRenderer) {
            const res = this.itemFormatter0(engine, ht, defaultRenderer)
            // АН 2026 08 15 / ODOO-4997 (замечание Игоря п.8): мини-гистограмма
            // прихода/расхода точки — ПОВЕРХ пузырька, ошибки не роняют рендер
            try { this.bubbleBars(engine, ht) } catch (e) { /* столбики — best effort */ }
            return res
        },
        bubbleBars(engine, ht) {
            const bIn = this.attr?.bubble_bars_in, bOut = this.attr?.bubble_bars_out
            if ((!bIn && !bOut) || !ht?.point || this.attr?.bubble_bars_mode === 'off') return
            const src = ht.item?.__src || ht.item
            if (!src) return
            const vIn = bIn ? Math.abs(+src[bIn]) || 0 : 0
            const vOut = bOut ? Math.abs(+src[bOut]) || 0 : 0
            if (!vIn && !vOut) return
            const mx = this.barsMax()
            if (!mx) return
            // высота столбика — доля от МАКСИМУМА по отчёту (сравнимость точек)
            const H = +this.attr?.bubble_bars_height || 22
            const W = +this.attr?.bubble_bars_width || 4
            const cIn = this.attr?.bubble_bars_in_color || '#2e7d32'
            const cOut = this.attr?.bubble_bars_out_color || '#c62828'
            const hIn = vIn ? Math.max(2, Math.round(H * vIn / mx)) : 0
            const hOut = vOut ? Math.max(2, Math.round(H * vOut / mx)) : 0
            const x = ht.point.x, y = ht.point.y
            // IE 2026 08 15 (заказ Игоря «сделай красивее»): скруглённые углы
            // (SVG rx через CSS-класс), тонкая белая обводка — столбики читаются
            // и на пузыре, и на сетке; лёгкая прозрачность заливки
            const stIn = { fill: cIn, 'fill-opacity': 0.9, stroke: '#ffffff', 'stroke-width': 0.75 }
            const stOut = { fill: cOut, 'fill-opacity': 0.9, stroke: '#ffffff', 'stroke-width': 0.75 }
            if ((this.attr?.bubble_bars_mode || 'paired') === 'updown') {
                // приход вверх, расход вниз от центра точки
                if (hIn) engine.drawRect(x - W - 1, y - hIn, W, hIn, 'bubble-flow-bar', stIn)
                if (hOut) engine.drawRect(x + 1, y, W, hOut, 'bubble-flow-bar', stOut)
            } else {
                // paired: оба столбика вверх, приход слева, расход справа
                if (hIn) engine.drawRect(x - W - 1, y - hIn, W, hIn, 'bubble-flow-bar', stIn)
                if (hOut) engine.drawRect(x + 1, y - hOut, W, hOut, 'bubble-flow-bar', stOut)
            }
        },
        barsMax() {
            // максимум прихода/расхода по отчёту — кэш, сброс в watcher'е rows
            if (this._barsMax != null) return this._barsMax
            const bIn = this.attr?.bubble_bars_in, bOut = this.attr?.bubble_bars_out
            let mx = 0
            const [doc, binding] = this.store.attr_get_link(this.WIDGET, this.attr) || []
            for (const r of ((doc || {})[binding] || [])) {
                if (bIn) mx = Math.max(mx, Math.abs(+r[bIn]) || 0)
                if (bOut) mx = Math.max(mx, Math.abs(+r[bOut]) || 0)
            }
            this._barsMax = mx
            return mx
        },
        itemFormatter0(engine, ht, defaultRenderer) {
            const row = ht?.item
            const src = row?.__src
            const lvl = this.levelColor(row)
            // АН 2026 08 15 / ODOO-4997: точка, подсвеченная из другого виджета
            // (канал wscm-dim-highlight) — рыжая обводка поверх цвета класса
            if (src?.__dimHl) {
                if (lvl) engine.fill = this.rgba(lvl, .78)
                engine.stroke = 'rgb(255, 150, 30)'
                engine.strokeWidth = 3
                return defaultRenderer()
            }
            // IE 2026 09 16: узлы, выделенные прямоугольником (Shift + протяжка) — тёмная обводка
            // IE 2026 09 16 (уточнение Игоря): выбранный кликом узел — тёмная обводка, как у узлов прямоугольника
            if (src && this.selectedRow && (this.selectedRow.__src || this.selectedRow) === src) {
                if (lvl) engine.fill = this.rgba(lvl, .85)
                engine.stroke = '#1f2937'; engine.strokeWidth = 2.5
                return defaultRenderer()
            }
            if (src && this._rectSet && this._rectSet.has(src)) {
                if (lvl) engine.fill = this.rgba(lvl, .85)
                engine.stroke = '#1f2937'; engine.strokeWidth = 2.5
                return defaultRenderer()
            }
            if (src && this.hasSelection) {
                if (src.selector) {
                    // фиолетовый: рыжий сливался с классом Below min (АН 09.08)
                    engine.fill = this.attr?.bubble_activeColor || '#8e24aa'
                    engine.stroke = this.attr?.bubble_activeStroke || '#4a148c'
                    engine.strokeWidth = 2
                    const res = defaultRenderer()
                    // номер пары в ОБЩЕМ списке отбора — одинаковый на всех баблах
                    // группы: видно, какая точка какая (АН 09.08)
                    const n = this.pairIndex(src)
                    if (n && ht.point) {
                        const pt = ht.point.clone()
                        pt.x += this.pointRadius(row) + 3
                        pt.y -= 3
                        engine.drawString(String(n), pt, 'bubble-sel-num')
                    }
                    return res
                }
                // не выбранные приглушаем МЯГКО: сильная прозрачность (.25)
                // искажала цвета классов до неразличимости (АН 09.08)
                engine.fill = lvl ? this.rgba(lvl, .5)
                    : (this.attr?.bubble_dimColor || 'rgba(130,177,255,.5)')
                return defaultRenderer()
            }
            if (lvl) {
                engine.fill = this.rgba(lvl, .78)
                engine.stroke = lvl
            }
            return defaultRenderer()
        },
        // номер пары в общем списке (1..N): порядок — как в SEL-строке отбора,
        // он общий для всех баблов группы
        pairIndex(src) {
            const i = [...this.pairIds].indexOf(this.pairKey(src))
            return i >= 0 ? i + 1 : 0
        },
        cfTaskColorOf(task) {
            if (task && task.__classColor) return task.__classColor // АН 2026 08 15
            return cfTaskColor(task, { vivid: true }) || '#4a90d9'
        },
        // Показатель, от которого зависит раскраска, + сработавший уровень —
        // для подсказки и плашки точки: «Grade: warning (Риск)»
        levelInfo(row) {
            if (!row || !this.levelBinding) return null
            if ([this.bindingX, this.bindingY, this.bindingSize].includes(this.levelBinding)) return null
            const src0 = row.__src || row
            const raw = src0[this.levelBinding] ?? this.store.get_value(src0, this.levelBinding)
            if (raw == null || raw === '') return null
            const rules = this.cfRules()
            const tasks = rules ? cfFieldTasks(rules, this.levelBinding) : []
            let matched = null
            if (tasks.length) {
                const src = row.__src || row
                const ctx = { getValue: (o, b) => this.store.get_value(o, b) }
                for (const task of tasks) {
                    if (cfCheckWHERE(task, src, this.levelBinding, null, ctx)) matched = task.title || matched
                }
            }
            const v = (typeof raw === 'number') ? Number(raw).toLocaleString('ru-RU') : String(raw)
            // color — шарик класса на плашке (АН 09.08: «подсветить значение цветом»)
            return { title: this.measureTitle(this.levelBinding), value: matched ? `${v} (${matched})` : v,
                     color: this.levelColor(row) || null }
        },
        rgba(color, a) {
            // цвет может прийти и hex-ом из настроек, и rgb()-строкой из
            // computed style CSS-класса правила (cfTaskColor)
            const s = String(color || '')
            const m = s.match(/rgba?\(([^)]+)\)/)
            if (m) {
                const [r, g, b] = m[1].split(',').map(x => parseFloat(x))
                return `rgba(${r},${g},${b},${a})`
            }
            if (s.startsWith('#') && s.length >= 7) {
                const n = parseInt(s.slice(1, 7), 16)
                return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`
            }
            return s
        },
        numOrNull(v) {
            // пустая настройка = «не ограничивать»: у wijmo min/max это null, не 0
            return (v === '' || v === null || v === undefined || isNaN(+v)) ? null : +v
        },
        attrResize() {
            // Высота чарта — от НИЗА виджета, а не от содержимого: процентная высота
            // внутри flex-родителя без заданной высоты давала петлю ResizeObserver
            // (замер: 1755 → 2280 → 2757 px за 6 с и дальше).
            const elementForm = document.getElementById(`WIDGET${this.widget_id}`)
            const elementFlex = document.getElementById(this.attr?.html_id)
            if (!elementForm || !elementFlex) return
            // легенда классов — статичная строка ПОД чартом: её высоту вычитаем (IE 2026 09 15: полоса может стоять сверху / сбоку —
            // тогда высота чарта от его собственного верха до низа виджета)
            const levels = this.$refs.attr_container?.querySelector('.bubble-levels')
            const lb = levels ? levels.getBoundingClientRect() : null
            const box = { w: lb ? Math.ceil(lb.width) : 0, h: lb ? Math.ceil(lb.height) : 0 }
            if (box.w !== this.levelsBox.w || box.h !== this.levelsBox.h) this.levelsBox = box
            const zi = this.$refs.zoomIsland, zw = zi ? Math.ceil(zi.getBoundingClientRect().width) : 0   // IE 2026 09 15: островок масштаба справа внизу
            if (zw !== this.zoomBox.w) this.zoomBox = { w: zw }
            const levelsH = this.stripSide === 'bottom' ? box.h : 0
            const newHeight = Math.max(200,
                Math.floor(elementForm.getBoundingClientRect().bottom - elementFlex.getBoundingClientRect().top) - 2 - levelsH)
            if (Math.abs(elementFlex.getBoundingClientRect().height - newHeight) > 1) {
                elementFlex.style.height = `${newHeight}px`
                this.flex?.invalidate()
            }
            this.catAxisFont()   // IE 2026 09 16: кегль подписей плотной оси Y — по новой высоте
        },
        applyOptions() {
            if (!this.flex) return
            this.flex.chartType = wjChart.ChartType.Bubble
            this.flex.options = {
                ...(this.flex.options || {}),
                bubble: {
                    minSize: Number(this.attr?.bubble_minSize) || 5,
                    maxSize: Number(this.attr?.bubble_maxSize) || 30,
                },
            }
        },
        // Измерения точки в плашке: поля селектора виджета (Set dimensions) —
        // те же, по которым ставится отбор; фолбэк — bubble_filter_binding/bubble_label.
        filterBindings() {
            const fs = (this.WIDGET?.record?.doc?.params?.fieldSelectors || [])
                .map(f => f.binding).filter(Boolean)
            if (fs.length) return fs
            const raw = this.attr?.bubble_filter_binding || this.attr?.bubble_label || ''
            // разделители , и & — «object & subject» задаёт комбинацию (пересечение)
            return String(raw).split(/[,&]/).map(s => s.trim()).filter(Boolean)
        },
        // Радиус пузырька строки: wijmo раскладывает меру размера по диапазону
        // minSize…maxSize — по нему же решаем, попал клик в точку или мимо.
        pointRadius(row) {
            const minSize = Number(this.attr?.bubble_minSize) || 5
            const maxSize = Number(this.attr?.bubble_maxSize) || 30
            const bs = this.bindingSize
            if (!bs || !row) return maxSize
            const values = this.rows.map(r => +r[bs]).filter(Number.isFinite)
            const min = Math.min(...values), max = Math.max(...values)
            if (!(max > min)) return maxSize
            return minSize + ((+row[bs] - min) / (max - min)) * (maxSize - minSize)
        },
        // IE 2026 09 15 (замечание Игоря, вечер, уточнение): плашка узла — по клику; повторный клик по тому же узлу закрывает её, клик мимо
        // узлов / Esc — тоже; по наведению — только подсветка узла и теги на осях (hoverAt)
        // ---- IE 2026 10 13 / ODOO-5800 (бот на проде, ieSIGM_001; заказ Игоря «клик → список позиций»): обычный клик по пузырю в режиме dims сразу ставит
        // селекторы стола по каналам fieldSelectors (значения исходной строки точки, например metric + grade) — тот же путь, что флажок плашки (onApplySelector__Click,
        // значения — selector_values); повторный клик по тому же пузырю снимает. Плашка — Shift / Alt / Ctrl / Cmd + клик или правая кнопка. Режим pair, нет каналов,
        // телефон, флаг fe.ux.chartClickSelectors выкл — прежний клик (плашка). true — клик обработан
        bubbleSel_on() {   // IE 2026 10 13 / ODOO-5800
            if (this.isPairSelect || !this.WIDGET?.vueObj) return false
            return chartClickSel_on((k, d) => this.store?.setting?.(k, d)) && chartClickSel_selectors(this.WIDGET?.record?.doc?.params?.fieldSelectors).length > 0
        },
        bubbleSel_click(e, row) {   // IE 2026 10 13 / ODOO-5800
            try {
                if (!this.bubbleSel_on()) return false
                const fieldSelectors = this.WIDGET.record.doc.params.fieldSelectors
                const src = row?.__src || row
                const target = chartClickSel_rowTarget({ fieldSelectors, item: src, getValue: (r, b) => this.store.get_value(r, b) })
                const WHERE = this.store.WORKSPACES?.[this.WIDGET.workspace]?.record?.doc?.params?.WHERE
                const d = chartClickSel_decide({ on: true, fieldSelectors, mobile: !!this.store?.mobileUi?.on, event: e, target, current: target ? chartClickSel_current(fieldSelectors, WHERE) : null })
                if (d !== 'select' && d !== 'clear') return false
                const [doc, binding] = this.store.attr_get_link(this.WIDGET, this.attr) || []
                for (const r of ((doc || {})[binding] || [])) if (r) { const want = d === 'select' && r === src; if (!!r.selector !== want) r.selector = want }   // признак отбора строки — как у флажка плашки (подсветка точки)
                this.pickerCloseCancel(); this.picker = null; this.hoverFormMode = false
                this.selectedRow = d === 'select' ? row : null
                this.bubble_emitDimHighlight()
                this.store.executeStoreMethod(this.WIDGET.vueObj, { command: 'onApplySelector__Click', selector_values: d === 'select' ? target.values : {} }, this.attr)
                this.flex?.invalidate()
                return true
            } catch (err) { return false }
        },
        // правая кнопка по пузырю при клике-селекторе — прежняя плашка (как прежний клик); мимо пузырей / без режима — меню как было
        bubbleSel_onContextMenu(e) {   // IE 2026 10 13 / ODOO-5800
            if (!this.flex || !this.bubbleSel_on()) return
            let ht = null
            try { ht = this.flex.hitTest(e) } catch (err) { ht = null }
            const row = ht?.item
            if (!row || !(ht.distance <= this.pointRadius(row) + 2)) return
            e.preventDefault(); e.stopPropagation()
            this.chart_onClick(e, true)
        },
        chart_onClick(e, legacy = false) {   // IE 2026 10 13 / ODOO-5800: legacy — прежний клик (плашка) из правой кнопки
            if (!this.flex) return
            if (this._rectJustDone) { this._rectJustDone = false; return }   // отпускание после протяжки — не клик
            const ht = this.flex.hitTest(e)
            const row = ht?.item
            this._lastClick = { near: !!row && ht.distance <= this.pointRadius(row) + 2, same: !!(this.picker && this.picker.row === row), mode: this.hoverFormMode, inRows: this.rows.includes(row), t: Date.now() }   // отладка / пробы
            // hitTest отдаёт БЛИЖАЙШУЮ точку, как бы далеко ни кликнули: без проверки
            // расстояния клик по пустому месту выбирал случайную позицию
            if (!row || !(ht.distance <= this.pointRadius(row) + 2)) { this.picker = null; this.hoverTagsHide(); this.rectClear(); return }
            if (!legacy && this.bubbleSel_click(e, row)) return   // IE 2026 10 13 / ODOO-5800: клик по пузырю — селекторы стола; Shift / Alt / Ctrl / правая кнопка — плашка
            // IE 2026 09 16 (уточнение Игоря): клик по узлу — переключатель режима «плашка измерений по наведению»: включил — плашка сразу
            // у этого узла и дальше следует за курсором по узлам; выключил — плашка закрыта, по наведению только кольцо и теги
            // IE 2026 09 16 (уточнение Игоря): клик по узлу ВЫБИРАЕТ его — окно легенды держит его показатели и после ухода курсора (наведение на
            // другие узлы показывает их, уход — снова выбранный); клик по выбранному узлу — снять выбор и выключить режим плашки
            const same = !!this.selectedRow && (this.selectedRow.__src || this.selectedRow) === (row.__src || row)
            if (same) { this.hoverFormMode = false; this.selectedRow = null; this.pickerCloseCancel(); this.picker = null }
            else { this.selectedRow = row; this.hoverFormMode = true; this.pickerShow(row, e) }
            this.flex?.invalidate()
        },
        // плашка узла у курсора (+12px, разворот к точке другой стороной у края виджета); pinned — прикололи кликом
        pickerShow(row, e) {
            const bindings = this.filterBindings()
            // справочник мог уже приехать, а титулы в строки ещё не дописаны —
            // иначе в плашке мелькнёт id
            this.resolveLabels('fill')

            // wijmo-подсказка могла остаться видимой с ховера: пока открыта плашка,
            // прячем её ЖЁСТКО и глушим контент — иначе на экране два тултипа
            this.flex?.tooltip?.hide?.()
            if (this.flex?.tooltip) this.flex.tooltip.content = ''
            const box = this.$refs.attr_container?.getBoundingClientRect()
            this.picker = {
                row,
                bindings,
                active: !!row.__src?.selector,
                x: Math.round(e.clientX - (box?.left || 0)) + 12,
                y: Math.round(e.clientY - (box?.top || 0)) + 12,
            }
            // tooltipContent при открытой плашке отдаёт пустоту, но УЖЕ показанную
            // подсказку wijmo это не убирает — прячем явно, иначе две плашки рядом (IE 2026 09 15: и после обработчиков wijmo)
            this.flex?.tooltip?.hide?.()
            setTimeout(() => { if (this.picker) this.flex?.tooltip?.hide?.() }, 0)
            // плашка не должна вылезать за виджет: если справа/снизу не помещается,
            // разворачиваем её к точке другой стороной
            this.$nextTick(() => {
                const panel = this.$refs.picker_panel?.getBoundingClientRect()
                const area = this.$refs.attr_container?.getBoundingClientRect()
                if (!panel || !area || !this.picker) return
                if (this.picker.x + panel.width + 8 > area.width) {
                    this.picker.x = Math.max(4, this.picker.x - panel.width - 24)
                }
                if (this.picker.y + panel.height + 8 > area.height) {
                    this.picker.y = Math.max(4, this.picker.y - panel.height - 24)
                }
            })
        },
        // ---- IE 2026 09 15 (замечание Игоря, вечер; уточнение): наведение на узел — подсветка кольцом и подписи значений X / Y на осях
        // (как теги точки у графика); плашка — по клику. Выкл: window.feSettings.set('fe.ux.bubbleHoverTags', false) — подсказка wijmo по наведению
        hoverFormOn() { try { return this.store.setting('fe.ux.bubbleHoverTags', true) !== false } catch (e) { return true } },
        chart_onMouseMove(e) {
            if (!this.hoverFormOn() || !this.flex || this.configError) return
            this._hoverEv = e
            if (this._hoverRaf) return
            this._hoverRaf = requestAnimationFrame(() => { this._hoverRaf = null; this.hoverAt(this._hoverEv) })
        },
        chart_onMouseLeave() {
            this.hoverTagsHide()
            if (this.hoverRow) this.hoverRow = null
            if (this.picker && !this._pickerHover) this.pickerCloseSoon()
        },
        // зона «моста» до плашки: её прямоугольник с полем 24px — путь курсора от узла к чекбоксу не закрывает плашку
        pickerBridge(e) {
            const p = this.$refs.picker_panel?.getBoundingClientRect()
            return !!p && e.clientX >= p.left - 24 && e.clientX <= p.right + 24 && e.clientY >= p.top - 24 && e.clientY <= p.bottom + 24
        },
        pickerHoverIn() { this._pickerHover = true; this.pickerCloseCancel() },
        pickerHoverOut() { this._pickerHover = false; if (this.picker) this.pickerCloseSoon() },
        pickerCloseSoon() {
            this.pickerCloseCancel()
            this._pickerCloseT = setTimeout(() => { this._pickerCloseT = null; if (this.picker && !this._pickerHover) this.picker = null }, 320)
        },
        pickerCloseCancel() { if (this._pickerCloseT) { clearTimeout(this._pickerCloseT); this._pickerCloseT = null } },
        // ---- IE 2026 09 16 (замечание Игоря): Shift + протяжка — выбор узлов прямоугольником, итоги в окне легенды
        rect_onDown(e) {
            if (!e.shiftKey || e.button !== 0 || !this.flex) return
            e.preventDefault(); e.stopImmediatePropagation()   // жесты wijmo (масштаб рамкой) на том же хосте — не запускать
            const box = this.$refs.attr_container?.getBoundingClientRect(); if (!box) return
            this._rect = { x0: e.clientX - box.left, y0: e.clientY - box.top, box }
            this.rectBox = { x: this._rect.x0, y: this._rect.y0, w: 0, h: 0 }
            document.addEventListener('pointermove', this.rect_onMove, true)
            document.addEventListener('pointerup', this.rect_onUp, true)
        },
        rect_onMove(e) {
            const r = this._rect; if (!r) return
            const x = e.clientX - r.box.left, y = e.clientY - r.box.top
            this.rectBox = { x: Math.min(r.x0, x), y: Math.min(r.y0, y), w: Math.abs(x - r.x0), h: Math.abs(y - r.y0) }
        },
        rect_onUp(e) {
            document.removeEventListener('pointermove', this.rect_onMove, true)
            document.removeEventListener('pointerup', this.rect_onUp, true)
            const r = this._rect, rb = this.rectBox; this._rect = null
            if (!r || !rb || (rb.w < 4 && rb.h < 4)) { this.rectBox = null; return }
            e.preventDefault(); e.stopImmediatePropagation(); this._rectJustDone = true; setTimeout(() => { this._rectJustDone = false }, 300)
            const flex = this.flex, host = flex?.hostElement; if (!host) { this.rectBox = null; return }
            const hb = host.getBoundingClientRect(), cb = this.$refs.attr_container.getBoundingClientRect()
            const dx = hb.left - cb.left, dy = hb.top - cb.top   // координаты узлов — от хоста графика, прямоугольник — от контейнера
            const sel = []
            for (const row of this.rows) {
                let px = null, py = null
                try { px = flex.axisX.convert(+row[this.bindingX]); py = flex.axisY.convert(+row[this.bindingY]) } catch (err) { continue }
                if (!Number.isFinite(px) || !Number.isFinite(py)) continue
                const cx = px + dx, cy = py + dy
                if (cx >= rb.x && cx <= rb.x + rb.w && cy >= rb.y && cy <= rb.y + rb.h) sel.push(row)
            }
            this.rectSel = sel
            this._rectSet = new Set(sel.map(x => x.__src || x))
            if (!sel.length) this.rectBox = null
            if (this.picker) this.picker = null
            flex.invalidate()
        },
        rectClear() {
            if (!this.rectSel.length && !this.rectBox) return
            this.rectSel = []; this._rectSet = null; this.rectBox = null
            this.flex?.invalidate()
        },
        // показатели узла (X, Y, размер, класс, доп. поля bubble_picker_fields); row = null — те же строки с пустыми значениями (заделы).
        // IE 2026 09 16 (уточнение Игоря): мера размера пузырька — ПЕРВОЙ, с пометкой size
        nodeMeasures(row) {
            const v = (b) => row ? this.measureValue(row, b) : ''
            const out = []
            // IE 2026 09 23 / ODOO-341407: i18n — подсказки блоков
            if (this.bindingSize) out.push({ title: this.titleSize, value: v(this.bindingSize), size: true, hint: this.t('{title} — bubble size', { title: this.titleSize }) })
            // IE 2026 09 16 (замечание Игоря): значения по осям X и Y — своими блоками легенды, как «Bubble size»
            out.push({ title: this.titleX, value: v(this.displayBindingX), axis: 'x', hint: this.t('{title} — X axis', { title: this.titleX }) })
            out.push({ title: this.titleY, value: v(this.displayBindingY), axis: 'y', hint: this.t('{title} — Y axis', { title: this.titleY }) })
            if (this.levelBinding && ![this.bindingX, this.bindingY, this.bindingSize].includes(this.levelBinding)) {
                const li = row ? this.levelInfo(row) : null
                out.push(li || { title: this.measureTitle(this.levelBinding), value: '' })
            }
            for (const item of String(this.attrText('bubble_picker_fields')).split(',').map(x => x.trim()).filter(Boolean)) {   // IE 2026 09 27 / ODOO-341407: bubble_picker_fields_{lang}
                const [b, title] = item.split('=').map(x => x.trim())
                out.push({ title: title || this.measureTitle(b), value: row ? (this.measureValue(row, b) || '—') : '' })
            }
            return out
        },
        // измерения узла (строки плашки) для любой строки
        dimRowsFor(row) {
            if (!row) return []
            return this.filterBindings().map(b => {
                const field = this.fields.find(f => f.binding === b)
                const seg = field?.relation_segment || ''
                const id = this.store.get_value(row.__src || row, b)
                return { title: this.measureTitle(b), value: this.valueTitle(row, b), binding: b, segment: (seg && id) ? seg : '', id, pi: this.segmentPi(seg) }
            })
        },
        // итоги по выделенным узлам: суммы числовых мер (X, Y, размер, числовые доп. поля) и число узлов по классам
        totalMeasures(rows) {
            const sumOf = (b) => { let s = 0, n = 0; for (const r of rows) { const v = +(r?.[b] ?? (r?.__src ? this.store.get_value(r.__src, b) : NaN)); if (Number.isFinite(v)) { s += v; n++ } } return n ? s : null }
            const fmt = (b, v) => { if (v === null) return '—'; const attr = this.fields.find(f => f.binding === b); if (attr?.attr_type === 'AttrTime') return this.store.formatTimeHTML(v, attr); const t = Math.round(v).toLocaleString('ru-RU'); return attr?.attr_type === 'AttrDays' ? this.t('{n} d', { n: t }) : t }   // IE 2026 09 23 / ODOO-341407: i18n
            const out = []
            const add = (title, b, extra) => { if (b) out.push({ title: `Σ ${title}`, value: fmt(b, sumOf(b)), ...(extra || {}) }) }
            // IE 2026 09 23 / ODOO-341407: i18n — подсказки итогов
            add(this.titleSize, this.bindingSize, { size: true, hint: this.t('Σ {title} — bubble size', { title: this.titleSize }) })   // IE 2026 09 16: мера размера — первой
            if (this.bindingX !== '__x_idx') add(this.titleX, this.bindingX, { axis: 'x', hint: this.t('Σ {title} — X axis', { title: this.titleX }) })   // IE 2026 09 16: даты / категории не суммируются
            if (!this.yIsCatAxis) add(this.titleY, this.bindingY, { axis: 'y', hint: this.t('Σ {title} — Y axis', { title: this.titleY }) })
            for (const item of String(this.attrText('bubble_picker_fields')).split(',').map(x => x.trim()).filter(Boolean)) {   // IE 2026 09 27 / ODOO-341407: bubble_picker_fields_{lang}
                const [b, title] = item.split('=').map(x => x.trim())
                const attr = this.fields.find(f => f.binding === b)
                if (attr && ['AttrDate', 'AttrLink', 'AttrStr'].includes(attr.attr_type)) continue
                const v = sumOf(b); if (v !== null) out.push({ title: `Σ ${title || this.measureTitle(b)}`, value: fmt(b, v) })
            }
            const byClass = {}
            for (const r of rows) { const t = this.matchedLevelTitle(r.__src || r); if (t) byClass[t] = (byClass[t] || 0) + 1 }
            // IE 2026 09 27 / ODOO-341407: счёт — по базовому title, подпись — label (язык интерфейса)
            for (const t of this.cfLevelTasks.map(x => x.title)) if (byClass[t]) { const lt = this.cfLevelTasks.find(x => x.title === t); out.push({ title: lt?.label || t, value: String(byClass[t]), color: this.cfTaskColorOf(lt) }) }
            return out
        },
        // U6 (заказ Игоря: объяснение элементов по Alt): Alt над пузырьком — «How to read a bubble»: узел под курсором — тем же hitTest и порогом, что
        // наведение (hoverAt), в самой точке курсора; подсказка у самого пузырька и без дожития после Alt (плашку узла не перекрывает). Выключатель
        // fe.ux.uiHelp = false — как было (над пузырьком с Alt — объяснение области не показывается тоже)
        // источник «по точке» — на корне SVG, НЕ на хосте: на хосте висит v-uiHelp «chart.bubble.plot», и перерисовка компонента при наведении
        // (ядро: _refreshShown владельца показанной подсказки) подменяла бы объяснение пузырька объяснением области; SVG wijmo может пересоздать —
        // привязка повторяется после каждой отрисовки
        uiHelp6_bindPoint() {
            const svg = this.flex && this.flex.hostElement && this.flex.hostElement.querySelector('svg')
            if (!svg || svg.__altTipAt) return
            svg.__altTipAt = (x, y) => this.uiHelp6_pointTip(x, y)
            svg.setAttribute('data-alt-tip-at', '')
        },
        uiHelp6_pointTip(x, y) {
            const flex = this.flex
            if (!flex || !uiHelp_enabled()) return null
            let ht = null
            try { ht = flex.hitTest(new MouseEvent('mousemove', { clientX: x, clientY: y })) } catch (err) { ht = null }   // как событие мыши hoverAt
            const row = ht && ht.item
            if (!row || !(ht.distance <= this.pointRadius(row) + 2)) return null
            const html = uiHelp_html('chart.bubble.point')
            if (!html) return null
            let rect = null
            try {
                const hr = flex.hostElement.getBoundingClientRect()
                const px = flex.axisX.convert(+row[this.bindingX]), py = flex.axisY.convert(+row[this.bindingY])
                const r = Math.max(4, this.pointRadius(row) / 2)
                if (Number.isFinite(px) && Number.isFinite(py)) rect = new Rect(hr.left + px - r, hr.top + py - r, 2 * r, 2 * r)
            } catch (err) { rect = null }
            return { content: html, rect: rect || new Rect(x - 8, y - 8, 16, 16), noLinger: true }
        },
        hoverAt(e) {
            const flex = this.flex
            if (!flex || !e) return
            let ht = null
            try { ht = flex.hitTest(e) } catch (err) { ht = null }
            const row = ht?.item
            const near = !!row && ht.distance <= this.pointRadius(row) + 2
            if ((near ? row : null) !== this.hoverRow) this.hoverRow = near ? row : null   // показатели узла — в окно легенды
            // IE 2026 09 16 (замечание Игоря): по наведению — кольцо, теги на осях и плашка с измерениями узла (не приколота: уходит вместе
            // с курсором, если он не идёт к ней); приколотую кликом плашку наведение не трогает
            if (near) {
                this.hoverTags(row)
                if (!this.hoverFormMode) return   // режим плашки выключен — только кольцо, теги и окно легенды
                if (this.picker && this.picker.row === row) { this.pickerCloseCancel(); return }
                if (this.picker && this.pickerBridge(e)) { this.pickerCloseCancel(); return }   // курсор идёт к плашке через соседние узлы
                this.pickerCloseCancel()
                this.pickerShow(row, e)
            } else {
                this.hoverTagsHide()
                if (this.picker && !this._pickerHover && !this.pickerBridge(e)) this.pickerCloseSoon()
            }
        },
        // подписи значений узла на осях: X — под осью X (в Compact — внутри области у нижнего края), Y — у оси Y на высоте узла;
        // кольцо вокруг узла под курсором — понятно, к какому узлу относятся теги (уточнение Игоря 15.09)
        hoverTags(row) {
            const flex = this.flex, host = flex?.hostElement, pr = flex?._plotRect || flex?.plotRect
            if (!host || !pr || !row) return
            let tags = this._hoverTagEls
            if (!tags || tags.x.parentNode !== host) {
                tags = this._hoverTagEls = {}
                for (const k of ['x', 'y']) { const el = document.createElement('div'); el.className = 'bubble-hover-tag bubble-hover-tag-' + k; host.appendChild(el); tags[k] = el }
                const ring = document.createElement('div'); ring.className = 'bubble-hover-ring'; host.appendChild(ring); tags.ring = ring
                if (getComputedStyle(host).position === 'static') host.style.position = 'relative'
            }
            const xv = +row[this.bindingX], yv = +row[this.bindingY]
            let px = null, py = null
            try { px = flex.axisX.convert(xv); py = flex.axisY.convert(yv) } catch (err) { px = null }
            if (!Number.isFinite(px) || !Number.isFinite(py)) { this.hoverTagsHide(); return }
            const tx = tags.x, ty = tags.y
            const rr = this.pointRadius(row) / 2 + 3   // радиус wijmo = size / 2
            Object.assign(tags.ring.style, { display: 'block', left: (px - rr) + 'px', top: (py - rr) + 'px', width: (2 * rr) + 'px', height: (2 * rr) + 'px' })
            tx.innerHTML = this.measureValue(row, this.displayBindingX) || ''
            ty.innerHTML = this.measureValue(row, this.displayBindingY) || ''   // IE 2026 09 16: категория — её подпись, не индекс
            tx.style.display = 'block'; ty.style.display = 'block'
            const top = this.axisPositionX === 'Top', right = this.axisPositionY === 'Right'
            const cx = this.compactX && !this.xIsDateAxis
            tx.style.top = (cx ? (top ? pr.top + 2 : Math.max(pr.bottom - 18, 0)) : (top ? Math.max(pr.top - 18, 0) : Math.min(pr.bottom + 2, host.clientHeight - 16))) + 'px'
            tx.style.left = Math.max(Math.min(px - tx.offsetWidth / 2, host.clientWidth - tx.offsetWidth), 0) + 'px'
            ty.style.top = Math.max(py - 9, 0) + 'px'
            if (this.compactY) ty.style.left = (right ? Math.max(pr.right - ty.offsetWidth - 3, 0) : pr.left + 3) + 'px'
            else ty.style.left = (right ? Math.min(pr.right + 3, host.clientWidth - ty.offsetWidth) : Math.max(pr.left - ty.offsetWidth - 3, 0)) + 'px'
        },
        hoverTagsHide() { const t = this._hoverTagEls; if (t) for (const k in t) t[k].style.display = 'none' },
        picker_onOutside(e) {
            // клик мимо плашки и мимо полотна закрывает её (внутри плашки — @click.stop)
            if (!this.picker) return
            if (!this.$refs.attr_container?.contains(e.target)) this.picker = null
        },
        picker_onEscape(e) {
            if (e.key !== 'Escape') return
            // IE 2026 09 16: Esc, который снял прямоугольник / плашку / выбранный узел / режим плашки, на этом и заканчивается — до
            // Widget.handleKeydown (Esc закрывает активный виджет) он не доходит; Esc «без работы» проходит дальше, как раньше
            const had = !!((this.rectSel && this.rectSel.length) || this.rectBox || this.picker || this.selectedRow || this.hoverFormMode)
            const inside = !!this.$refs.attr_container?.contains(e.target)
            this.rectClear()   // IE 2026 09 16
            if (this.picker || this.selectedRow || this.hoverFormMode) { this.picker = null; this.hoverFormMode = false; this.selectedRow = null; this.flex?.invalidate() }   // Esc — снять выбор узла и режим плашки
            if (had && inside) e.stopPropagation()
        },
        //--------------------------------- быстрые настройки (шестерёнка)
        // Значения пишутся в doc.viewParams.<attr.name>.<param> и оттуда же читаются
        // (store.set_viewParam кладёт их и в attr) — то есть сохраняются с виджетом,
        // как у гистограммы, а не правкой JSON записи.
        onToggle_settings() {
            this.show_settings = !this.show_settings
        },
        onShow_settings() {
            clearTimeout(this.timerId_settings)
            this.timerId_settings = setTimeout(() => { this.show_settings = true }, this.store.setting('fe.ux.chartSettingsHoverMs', 200))   // IE 2026 09 05 / ODOO-336330
        },
        onClose_settings() {
            clearTimeout(this.timerId_settings)
            this.timerId_settings = setTimeout(() => { this.show_settings = false }, this.store.setting('fe.ux.hoverHideMs', 200))   // IE 2026 09 05 / ODOO-336330
        },
        set_viewParam(param, value) {
            this.store.set_viewParam(this.WIDGET, this.attr.name, param, value, this.attr)
            if (param === 'bubble_minSize' || param === 'bubble_maxSize') this.applyOptions()
            // IE 2026 09 15 (замечание Игоря): режимы легенды как у графика — Popup без Grouped включает Grouped и открывает окно,
            // выключение Grouped снимает Popup и закрывает окно
            // IE 2026 09 15 (замечание Игоря, вечер): ряд «Legend mode» снят — Popup стал значением Legend position: только окно легенды
            // (полоса классов скрыта); сторона (Auto / Left / …) — полоса классов на этой стороне, окно закрыто
            if (param === 'legend-position') {
                const popup = value === 'Popup'
                if (popup !== this.legendPopup) this.store.set_viewParam(this.WIDGET, this.attr.name, 'legend-popup', popup, this.attr)
                if (popup && !this.legendGrouped) this.store.set_viewParam(this.WIDGET, this.attr.name, 'legend-grouped', true, this.attr)
                this.levelsPanelVisible = popup
            }
            if (param === 'legend-popup' && value) {
                if (!this.legendGrouped) this.store.set_viewParam(this.WIDGET, this.attr.name, 'legend-grouped', true, this.attr)
                this.levelsPanelVisible = true
            } else if (param === 'legend-popup' && !value) {
                this.levelsPanelVisible = false
            } else if (param === 'legend-grouped' && !value) {
                if (this.legendPopup) this.store.set_viewParam(this.WIDGET, this.attr.name, 'legend-popup', false, this.attr)
                this.levelsPanelVisible = false
            }
            if (['compact-axisX', 'compact-axisY', 'axisX-position', 'axisY-position'].includes(param)) this.$nextTick(() => this.compactApply())
            if (['legend-position', 'legend-grouped', 'legend-popup'].includes(param)) this.$nextTick(() => this.attrResize())
            // кнопки панели — переключатели: пересчитать active у ВСЕХ, иначе
            // «Нет» и «Справа» горят одновременно
            this.set_commandsActive()
            this.$nextTick(() => this.flex?.invalidate())
        },
        get_viewParam(param, defaultValue) {
            return this.store.get_viewParam(this.WIDGET, this.attr.name, param, defaultValue, this.attr)
        },
        set_commandsActive() {
            // построить панель один раз, а active кнопок пересчитывать при КАЖДОМ
            // вызове (как в AttrChart) — иначе кнопки-переключатели не переключаются
            if (!this.commandPanel_topLeft.length) {
                const name = this.attr?.name
                if (!name) return
                // IE 2026 09 15 (замечание Игоря, вечер): старая запись с «Legend mode: Popup» — показать её как Legend position = Popup (без пометки modified)
                if (this.legendPopup && this.attr?.['legend-position'] !== 'Popup') this.store.set_viewParam(this.WIDGET, name, 'legend-position', 'Popup', this.attr, false)
                const btn = 'pi p-button-white p-button-border mr-1'
                const opt = (param, checkValue, title, def, defaultValue) => ({
                    binding: `doc.viewParams.${name}.${param}`,
                    checkValue, default: def, ...(defaultValue !== undefined ? { defaultValue } : {}),
                    showCommandTitle: true, title, command: 'set_viewParam', cssClass: btn,
                    // U6 (заказ Игоря: объяснение элементов по Alt)
                    ...(UI_HELP_QS_BUBBLE[param] ? { uiHelp: UI_HELP_QS_BUBBLE[param], uiHelpState: () => UI_HELP_QS_BUBBLE_STATE[param](this) } : {}),
                })
                const tip = (o, tooltip) => ({ ...o, tooltip })
                // IE 2026 09 23 / ODOO-341407: i18n — подписи (3-й аргумент opt) и подсказки (2-й аргумент tip); checkValue / default — значения
                // IE 2026 09 15 / ODOO-… (замечания Игоря): все подписи и подсказки — English; ряды осей и легенды — как у графика
                // (Axis Y / X position + Compact, Legend mode Grouped / Popup, Legend position); Compact и Grouped — по умолчанию
                this.commandPanel_topLeft = [
                    [
                        { attr_type: 'AttrLabel', title: this.t('Wheel zoom:'), cssClass: 'mr-2' },
                        tip(opt('bubble_axes', 'XY', this.t('Both axes'), 'XY', 'XY'), this.t('Mouse wheel / pinch zooms both axes; the island buttons at the bottom-right zoom the same axes')),
                        tip(opt('bubble_axes', 'X', this.t('X only'), 'XY'), this.t('Zoom only along the X axis')),
                        tip(opt('bubble_axes', 'Y', this.t('Y only'), 'XY'), this.t('Zoom only along the Y axis')),
                        tip(opt('bubble_gestures', false, this.t('Off'), true, true), this.t('No wheel zoom and no zoom island')),
                    ], [
                        // разброс мер в тысячи раз — логарифм часто читается лучше зума
                        { attr_type: 'AttrLabel', title: this.t('Log scale:'), cssClass: 'mr-2' },
                        tip(opt('axisX-logBase', 10, this.t('X'), 0), this.t('Logarithmic X axis (base 10) — values spread over thousands of times stay readable')),
                        tip(opt('axisY-logBase', 10, this.t('Y'), 0), this.t('Logarithmic Y axis (base 10)')),
                    ], [
                        { attr_type: 'AttrLabel', title: this.t('Axis Y position:'), cssClass: 'mr-2' },
                        opt('axisY-position', 'Auto', this.t('Auto'), 'Auto', 'Auto'),
                        opt('axisY-position', 'Left', this.t('Left'), 'Auto'),
                        opt('axisY-position', 'Right', this.t('Right'), 'Auto'),
                        tip(opt('compact-axisY', true, this.t('Compact'), true, true), this.t('Tick labels and the axis title inside the plot area — the plot takes the whole widget (default on)')),
                    ], [
                        { attr_type: 'AttrLabel', title: this.t('Axis X position:'), cssClass: 'mr-2' },
                        opt('axisX-position', 'Auto', this.t('Auto'), 'Auto', 'Auto'),
                        opt('axisX-position', 'Top', this.t('Top'), 'Auto'),
                        opt('axisX-position', 'Bottom', this.t('Bottom'), 'Auto'),
                        tip(opt('compact-axisX', true, this.t('Compact'), true, true), this.t('Tick labels and the axis title inside the plot area (default on; a date axis keeps its year tier below)')),
                    ], [
                        // IE 2026 09 15 (замечание Игоря, вечер): ряд «Legend mode» (Grouped / Popup) снят; Popup — значение Legend position
                        { attr_type: 'AttrLabel', title: this.t('Legend position:'), cssClass: 'mr-2' },
                        tip(opt('legend-position', 'Auto', this.t('Auto'), 'Auto', 'Auto'), this.t('Class strip below the plot')),
                        tip(opt('legend-position', 'Left', this.t('Left'), 'Auto'), this.t('Class strip to the left of the plot')),
                        tip(opt('legend-position', 'Top', this.t('Top'), 'Auto'), this.t('Class strip above the plot')),
                        tip(opt('legend-position', 'Right', this.t('Right'), 'Auto'), this.t('Class strip to the right of the plot')),
                        tip(opt('legend-position', 'Bottom', this.t('Bottom'), 'Auto'), this.t('Class strip below the plot')),
                        tip(opt('legend-position', 'Popup', this.t('Popup'), 'Auto'), this.t('Only the legend window (button in the top-right island): classes with point counts and show / hide toggles; the class strip beside the plot is hidden')),
                    ],
                ]
            }
            this.commandPanel_topLeft.forEach((panel, index) => {
                panel.forEach(command => this.store.set_commandActive(this, command))
                this.store.prepare_attrs(panel, `commandPanel${this.WIDGET.id}_${this.attr_id}_${index}`)
            })
        },
        pickerRows() {
            // IE 2026 09 15 (замечание Игоря): + сегмент и иконка записи измерения (открыть запись), id значения; IE 2026 09 16: общий dimRowsFor
            return this.picker ? this.dimRowsFor(this.picker.row) : []
        },
        // иконка сегмента (как у строк формы чипса: у подсегмента без иконки — иконка родителя; иначе pi-file)
        segmentPi(seg) {
            const IS = this.store.itemsSource?.SEGMENTS
            const byId = (id) => IS?.ids?.[id] || (IS?.data || []).find(x => x?.id === id)
            let rec = seg ? byId(seg) : null, guard = 0
            while (rec && !(rec.pi || rec.doc?.pi) && rec.parent && guard++ < 6) rec = byId(rec.parent)
            const pi = String(rec?.pi || rec?.doc?.pi || '').trim()
            return pi ? pi.replace(/^pi\s+/, '') : 'pi-file'
        },
        // IE 2026 09 15 (замечание Игоря): иконка измерения в плашке — открыть запись значения (та же команда, что у иконки в форме чипса)
        pickerOpen(r) {
            if (!r?.segment || r.id == null || r.id === '') return
            const vueObj = this.WIDGET?.vueObj || this
            this.store.executeStoreMethod(vueObj, { command: 'widget_open', widget: 'widget-record', _activate: true, item: { id: String(r.id), segment: r.segment } })
        },
        // IE 2026 09 15 (замечание Игоря): чекбокс плашки — отбор узла (пара измерений в pair-режиме): клик — добавить / снять,
        // Alt+клик — оставить только этот узел; плашка остаётся открытой с новым состоянием
        pickerToggle(e) {
            const p = this.picker, src = p?.row?.__src
            if (!src || !this.canSelect) return
            const exclusive = !!(e && e.altKey)
            if (exclusive) {
                const [doc, binding] = this.store.attr_get_link(this.WIDGET, this.attr) || []
                for (const r of ((doc || {})[binding] || [])) if (r && r !== src && r.selector) r.selector = false
                src.selector = true
            } else src.selector = !src.selector
            p.active = !!src.selector
            this.bubble_emitDimHighlight()
            if (this.isPairSelect) this.applyPairSelector(exclusive)
            else this.store.executeStoreMethod(this.WIDGET.vueObj, { command: 'onApplySelector__Click' }, this.attr)
            this.flex?.invalidate()
        },
        // значение меры с единицей: дни (AttrDays) подписываем явно — «DOS: 31 484»
        // без единицы читался как штуки (вопрос Андрея 09.08)
        measureValue(row, b) {
            const v = row?.[b] ?? (row?.__src ? this.store.get_value(row.__src, b) : undefined)
            if (v == null || v === '') return ''
            const attr = this.fields.find(f => f.binding === b)
            // IE 2026 09 16: ссылочное поле — титул словаря (категории осей матрицы), не id
            if (attr && (attr.attr_type === 'AttrLink' || attr.relation_segment)) { const t = this.valueTitle(row.__src || row, b); if (t && t !== String(v)) return t }
            if (attr?.attr_type === 'AttrDate' || /^\d{4}-\d{2}-\d{2}/.test(String(v))) {
                return String(v).slice(0, 10)
            }
            const n = Number(v)
            if (!Number.isFinite(n)) return String(v)
            // IE 2026 09 10 / ODOO-5800: AttrTime (DOS в секундах, Offset) — «14m»/«12d» тем же форматтером, что грид
            if (attr?.attr_type === 'AttrTime') return this.store.formatTimeHTML(n, attr)
            const s = n.toLocaleString('ru-RU')
            return attr?.attr_type === 'AttrDays' ? this.t('{n} d', { n: s }) : s   // IE 2026 09 23 / ODOO-341407: i18n
        },
        // IE 2026 09 10 / ODOO-5800: подписи оси для меры-длительности (AttrTime — секунды, AttrDays — дни):
        // сырые секунды на оси нечитаемы; для остальных мер — штатный числовой формат (null)
        axisDurationFormatter(binding) {
            const attr = this.fields.find(f => f.binding === binding)
            if (attr?.attr_type === 'AttrTime') {
                return (engine, label) => { label.text = this.store.formatTimeHTML(label.val, attr); return label }
            }
            if (attr?.attr_type === 'AttrDays') {
                return (engine, label) => { label.text = this.store.formatDaysHTML(label.val, attr); return label }
            }
            return null
        },
        // меры точки — в плашке, пока окно легенды закрыто (IE 2026 09 16: с открытым окном — в его нижнем блоке)
        pickerMeasures() { return this.picker ? this.nodeMeasures(this.picker.row) : [] },
        // IE 2026 09 16 (уточнение Игоря): группы плашки как в легенде — Bubble size / X axis / Y axis + остальные показатели
        pickerGroups() {
            const rows = this.pickerMeasures()
            const heads = []
            const size = rows.find(r => r.size), x = rows.find(r => r.axis === 'x'), y = rows.find(r => r.axis === 'y')
            // IE 2026 09 23 / ODOO-341407: i18n
            if (size) heads.push({ key: 'size', head: this.t('Bubble size'), cls: 'bubble-picker-sizepi', row: size })
            if (x) heads.push({ key: 'x', head: this.t('X axis'), cls: 'bubble-picker-axispi bubble-picker-axispi-x', row: x })
            if (y) heads.push({ key: 'y', head: this.t('Y axis'), cls: 'bubble-picker-axispi bubble-picker-axispi-y', row: y })
            return { heads, rest: rows.filter(r => !r.size && !r.axis) }
        },
        // Отбор точки — ШТАТНЫМ селектором воркспейса (ODOO-4429): ставим флаг
        // row.selector на оригинальной строке выборки. В режиме 'dims' дальше всё
        // делает onApplySelector__Click (как чекбокс листа данных). В режиме 'pair'
        // (ODOO-4442) id выбранных строк уходят одним SEL типа selector_map_values:
        // бэк кладёт этот набор в calc БЕЗ запроса и без перемножения измерений —
        // приёмники фильтруются по id, комбинации точные. Запись виджета не меняется.
        // АН 2026 08 15 / ODOO-4997: клик по кружку подсвечивает строки с этими object/subject в соседних виджетах (Demand & Supply
        // Balance и др.) — тот же канал, что у графа Supply Chain Flow; эмит ДО каскада отборов. IE 2026 09 15: кнопка «Отобрать» плашки
        // заменена чекбоксом (pickerToggle), applyPicker остался для внешних вызовов
        applyPicker() { this.pickerToggle(null) },
        bubble_emitDimHighlight() {
            // АН 2026 08 15 / ODOO-4997: выделенные (selector) точки → значения
            // измерений object/subject (uuid + титул) страничным событием
            try {
                const [doc, binding] = this.store.attr_get_link(this.WIDGET, this.attr) || []
                const values = []
                const seen = new Set()
                const monthsSeen = new Set()
                for (const r of ((doc || {})[binding] || [])) {
                    if (!r?.selector) continue
                    // АН 2026 08 15 / ODOO-4997 (п.7): дата точки — в сигнал (месяц)
                    const mo = String(this.store.get_value(r, 'month') || '').slice(0, 7)
                    if (/^\d{4}-\d{2}$/.test(mo) && !monthsSeen.has(mo)) {
                        monthsSeen.add(mo)
                        const last = new Date(+mo.slice(0, 4), +mo.slice(5, 7), 0).getDate()
                        values.push({ kind: 'date', from: mo + '-01', to: mo + '-' + String(last).padStart(2, '0') })
                    }
                    for (const b of ['object', 'subject']) {
                        const v = this.store.get_value(r, b)
                        const key = v === undefined || v === null ? '' :
                            (typeof v === 'object' ? String(v.id ?? v.value ?? '') : String(v))
                        if (!key || seen.has(key)) continue
                        seen.add(key)
                        values.push({ key, kind: b, bare: key.split('::')[0] !== key ? key.split('::')[0] : undefined,
                                      label: this.valueTitle(r, b) || key })
                    }
                }
                // IE 2026 08 17 / ODOO-4997 (решение Игоря, «строго»): отдаём только
                // измерения из Set fields виджета (+дата, если в списке 'date'); пусто — молчим
                const _allowDate = this.store.selDate_of(this.WIDGET, 'set').includes('date') // IE 2026 08 18: из таблицы selection_fields
                const gated = this.store.selDims_filter(this.WIDGET, 'set', values, _allowDate)
                if (!gated.length) return
                values.length = 0; values.push(...gated)
                if (window.__simDebug) console.log('sim: bubble emit dim-highlight', values.length, 'values')
                window.dispatchEvent(new CustomEvent('wscm-dim-highlight', {
                    detail: { source: this.WIDGET?.id, page: this.WIDGET?.page, values },
                }))
            } catch (e) { console.warn('bubble dim-highlight skipped', e) }
        },
        applyDimHighlight(detail) {
            // АН 2026 08 15 / ODOO-4997: приём подсветки от других виджетов —
            // ТИХО помечаем точки (__dimHl), НИКОГДА не ре-эмитим (анти-цикл)
            if (!detail || detail.source === this.WIDGET?.id) return
            // IE 2026 08 17 / ODOO-4997 (решение Игоря, «строго»): принимаем только
            // измерения из Get fields (+дата, если в списке 'date'); пусто — не реагируем
            {
                const _getDate = this.store.selDate_of(this.WIDGET, 'get').includes('date') // IE 2026 08 18: из таблицы selection_fields
                const _gv = this.store.selDims_filter(this.WIDGET, 'get', detail.values, _getDate)
                if (!_gv.length) return
                detail = { ...detail, values: _gv }
            }
            // АН 2026 08 15 / ODOO-4997 (замечание Игоря п.4): типизированный матч —
            // при наличии СУБЪЕКТНЫХ ключей точка подсвечивается только по
            // совпадению субъекта (объект-ключ совпадает у ВСЕХ точек при фильтре
            // по объекту и метил бы всё); объект — доп-условие, если задан
            let kSubj = new Set(), kObj = new Set(), kAny = new Set()
            const kDates = []
            for (const v of detail.values || []) {
                if (v?.kind === 'date') { if (v.from) kDates.push({ from: v.from, to: v.to || v.from }); continue }
                const dst = v?.kind === 'subject' ? kSubj : v?.kind === 'object' ? kObj : kAny
                for (const k of [v?.key, v?.bare, v?.label, v?.doc_id]) if (k) { dst.add(String(k)); kAny.add(String(k)) }
            }
            // IE 2026 08 15 (замечание Игоря п.13): сигнал «ТОЛЬКО дата» (выделен
            // период в гриде после узла графа) — СУЖАЕМ прежний субъектный
            // контекст по дате, а не оставляем все точки субъекта
            if (!kSubj.size && !kObj.size && !kAny.size) {
                if (kDates.length && this._dimLastKeys) {
                    kSubj = new Set(this._dimLastKeys.s)
                    kObj = new Set(this._dimLastKeys.o)
                    kAny = new Set(this._dimLastKeys.a)
                } else if (!kDates.length) {
                    this._dimLastKeys = null // полное снятие — контекст забыт
                }
            } else {
                this._dimLastKeys = { s: [...kSubj], o: [...kObj], a: [...kAny] }
            }
            try {
                const [doc, binding] = this.store.attr_get_link(this.WIDGET, this.attr) || []
                const valOf = (r, b) => {
                    const v = this.store.get_value(r, b)
                    return v === undefined || v === null ? '' :
                        (typeof v === 'object' ? String(v.id ?? v.value ?? '') : String(v))
                }
                const inSet = (set, s) => s && (set.has(s) || set.has(s.split('::')[0]))
                // АН 2026 08 15 / ODOO-4997 (замечание Игоря п.9): отчёт с ОДНИМ
                // объектом и ОДНИМ субъектом — сигналу различать нечего (совпало бы
                // всё) — выделение не трогаем вообще
                if (kSubj.size || kObj.size || kAny.size) {
                    const uo = new Set(), us = new Set()
                    for (const r of ((doc || {})[binding] || [])) {
                        const o = valOf(r, 'object'), s = valOf(r, 'subject')
                        if (o) uo.add(o); if (s) us.add(s)
                        if (uo.size > 1 || us.size > 1) break
                    }
                    if (uo.size <= 1 && us.size <= 1) {
                        if (window.__simDebug) console.log('sim: bubble dim-highlight ignored (single object+subject)')
                        return
                    }
                }
                let hits = 0
                const dateHit = (r) => {
                    if (!kDates.length) return true
                    const mo = String(this.store.get_value(r, 'month') || '').slice(0, 7)
                    if (!/^\d{4}-\d{2}$/.test(mo)) return true // точка без даты — не режем
                    const mFrom = mo + '-01', mTo = mo + '-31'
                    return kDates.some(d => d.from <= mTo && d.to >= mFrom)
                }
                for (const r of ((doc || {})[binding] || [])) {
                    let hit = false
                    if (kSubj.size) {
                        hit = inSet(kSubj, valOf(r, 'subject')) && (!kObj.size || inSet(kObj, valOf(r, 'object')))
                    } else if (kObj.size) {
                        hit = inSet(kObj, valOf(r, 'object'))
                    } else if (kAny.size) {
                        hit = inSet(kAny, valOf(r, 'object')) || inSet(kAny, valOf(r, 'subject'))
                    }
                    // АН 2026 08 15 / ODOO-4997 (п.7): дата в сигнале сужает до точек её периода
                    if (hit) hit = dateHit(r)
                    r.__dimHl = hit
                    if (hit) hits++
                }
                if (window.__simDebug) console.log('sim: bubble dim-highlight', kSubj.size + kObj.size + kAny.size, 'keys →', hits, 'points')
                this.flex?.invalidate()
            } catch (e) { /* чужой формат — молча */ }
        },
        // pair-режим: перевыборка и внешние правки SEL теряют/меняют флаги строк —
        // приводим row.selector к набору id селектора (bidirectional истина — SEL)
        pairKey(row) {
            return this.filterBindings().map(b => this.store.get_value(row, b)).join('&')
        },
        // класс точки по правилам: последнее совпавшее — как в levelInfo
        matchedLevelTitle(srcRow) {
            // АН 2026 08 15 / ODOO-4997: класс-канал — прямое сопоставление значения
            if (this.classEntries().length && srcRow) {
                const e = this.classEntryOf({ __src: srcRow })
                return e ? (e.title || String(e.value)) : null
            }
            const tasks = this.cfLevelTasks
            if (!tasks.length || !srcRow) return null
            const ctx = { getValue: (o, b) => this.store.get_value(o, b) }
            let matched = null
            for (const task of tasks) {
                if (cfCheckWHERE(task, srcRow, this.levelBinding, null, ctx)) matched = task
            }
            return matched ? (matched.title || '…') : null
        },
        // тумблеры классов из попап-легенды
        onLevelToggle(s) {
            const t = s.levelTitle
            this.hiddenLevels = { ...this.hiddenLevels, [t]: !this.hiddenLevels[t] }
        },
        onLevelGroupToggle(g, force) {
            const on = force === true ? true : force === false ? false : g.series.some(s => !s.visible)
            const map = {}
            for (const s of g.series) map[s.levelTitle] = !on
            this.hiddenLevels = map
        },
        onLevelSettings() {
            // ⚙ ведёт к полю уровня — там правила раскраски и титулы классов
            this.store.legend_goto_field = { binding: this.levelBinding }
            this.store.set_activeAttr(this.WIDGET.view, { binding: 'doc.viewList' }, this.WIDGET)
        },
        // СВОЯ ли SEL-строка пар: с группой — строка группы (общая на все баблы
        // группы), без — строка этого виджета (поведение до групп)
        isMyPairSel(w) {
            if (!w?.meta?.bubble_pair) return false
            return this.pairGroup ? w.meta.pair_group === this.pairGroup : w?.widget === this.WIDGET.widget
        },
        syncPairFlags() {
            if (!this.isPairSelect) return
            // Нет НАШЕГО селектора пар — не трогать флаги вовсе: инстанс бабла есть
            // у каждого WIDGET-LIST (вкладка Bubble), и синк с пустым набором стирал
            // чекбоксы селектора соседних таблиц сразу после клика (репорт Андрея:
            // «селектор сразу стирается, при том что фильтр ставится»)
            if (!this.pairSel) return
            const ids = this.pairIds
            const [doc, binding] = this.store.attr_get_link(this.WIDGET, this.attr) || []
            for (const r of ((doc || {})[binding] || [])) {
                const want = ids.has(this.pairKey(r))
                if (!!r.selector !== want) r.selector = want
            }
        },
        applyPairSelector(exclusive = false) {   // IE 2026 09 15: exclusive — Alt+клик: только этот узел (и пары других виджетов группы снимаются)
            const WORKSPACE = this.store.WORKSPACES?.[this.WIDGET?.workspace]
            const params = WORKSPACE?.record?.doc?.params
            if (!params) return
            const WHERE = params.WHERE = params.WHERE || []

            const bindings = this.filterBindings()
            const [doc, binding] = this.store.attr_get_link(this.WIDGET, this.attr) || []
            const rows = ((doc || {})[binding] || []).filter(r => r?.selector)
            const label = (r) => bindings.map(b => this.valueTitle(r, b)).filter(Boolean).join(' × ')

            let sel = WHERE.find(w => this.isMyPairSel(w))
            if (!sel) {
                sel = {
                    use: true,
                    // binding селектора произвольный: бэк ключует calc-набор по нему.
                    // У группы СВОЙ ключ — комбинации разных групп (товар×склад,
                    // страна×товар, …) образуют независимые грани и пересекаются
                    // в calc_all штатно, не затирая друг друга в каналах exclude
                    leftValue: {
                        value: this.pairGroup ? `bubble-pair::${this.pairGroup}` : 'bubble-pair',
                        valueStr: this.t('Positions'), attr_type: 'AttrLink',   // IE 2026 09 15: UI strings English   // IE 2026 09 23 / ODOO-341407: i18n
                    },
                    condition: 'in',
                    type: 'selector_map_pairs',
                    widget: this.WIDGET.widget,
                    'widget-segment': this.WIDGET.record?.segment || 'WIDGET-LIST',
                    meta: {
                        bubble_pair: true, pi: 'pi-filter',
                        ...(this.pairGroup ? { pair_group: this.pairGroup } : {}),
                    },
                    attrs: [],
                }
                WHERE.push(sel)
            }
            // Стабильная нумерация (АН 10.08): номер пары = позиция в списке, поэтому
            // ПРЕЖНИЙ порядок сохраняем, новые пары — строго В КОНЕЦ; выпадение из
            // середины (снятие) сдвигает только хвост. Сохраняются: пары, невидимые
            // этому виджету (другой горизонт — другое подмножество точек), и свои,
            // всё ещё отобранные.
            const dataKeys = new Set(((doc || {})[binding] || []).map(r => this.pairKey(r)))
            const selectedKeys = new Set(rows.map(r => this.pairKey(r)))
            const keyOf = (a) => {
                const v = a?.rightValue?.value
                return (v && typeof v === 'object') ? bindings.map(b => v[b]).join('&') : null
            }
            const kept = [], seen = new Set()
            for (const a of (exclusive ? [] : (sel.attrs?.[0]?.attrs || []))) {
                const k = keyOf(a)
                if (!k || seen.has(k)) continue
                if (!dataKeys.has(k) && this.pairGroup) { kept.push(a); seen.add(k); continue }
                if (selectedKeys.has(k)) { kept.push(a); seen.add(k) }
            }
            const added = rows.filter(r => !seen.has(this.pairKey(r))).map(r => ({
                use: true,
                // пара значений измерений — сервер резолвит её в id записей расчёта
                rightValue: {
                    value: Object.fromEntries(bindings.map(b => [b, this.store.get_value(r, b)])),
                    valueStr: label(r),
                },
            }))
            sel.attrs = [{ use: true, attrs: [...kept, ...added] }]
            sel.use = kept.length + added.length > 0
            this.store.workspace_applySelector(this.WIDGET.workspace, this.WIDGET.page, this.WIDGET)
        },
        tooltipContent(ht) {
            if (this.hoverFormOn()) return ''   // IE 2026 09 15 (замечание Игоря, вечер): вместо подсказки — теги на осях по наведению, плашка по клику
            const row = ht?.item
            if (!row) return ''
            // плашка точки открыта — она уже показывает эти же меры, две одинаковые
            // подсказки друг на друге перекрывали график
            if (this.picker) return ''
            const label = this.attr?.bubble_label ? `<b>${this.rowLabel(row)}</b><br/>` : ''
            const parts = [
                `${this.titleX}: ${this.measureValue(row, this.displayBindingX)}`,
                `${this.titleY}: ${this.measureValue(row, this.displayBindingY)}`,
            ]
            if (this.bindingSize) parts.push(`${this.titleSize}: ${this.measureValue(row, this.bindingSize)}`)
            const li = this.levelInfo(row)
            if (li) parts.push(`${li.title}: ${li.value}`)
            return label + parts.join('<br/>')
        },
    },
    watch: {
        // плашка закрылась — вернуть wijmo-подсказку (на время плашки контент глушится)
        picker(v) {
            if (!v && this.flex?.tooltip) this.flex.tooltip.content = this.tooltipContent
        },
        // меры пересчитываются сами (rows — вычисляемое); размеры пузырьков живут
        // в options чарта и требуют явного применения
        'attr.bubble_minSize': function () { this.applyOptions() },
        'attr.bubble_maxSize': function () { this.applyOptions() },
        rows: function () {
            this.resolveLabels()
            this.syncPairFlags()
            // датная ось: подписи и ярус-группы пересчитываем здесь (не в computed);
            // кэш максимума мини-гистограмм тоже устарел
            this._barsMax = null
            this._xAxisDates = this.computeXAxisDates(); this._xAxisCats = this.computeXAxisCats(); this._yAxisCats = this.computeYAxisCats()   // IE 2026 09 16: и категории
            this.$nextTick(() => { this.applyDateAxis(); this.applyCatAxisY(); this.attrResize() })
        },
        // попап-легенда открыта/закрыта — полоса классов под чартом прячется/
        // возвращается, высоту чарта пересчитать
        levelsPanelVisible: function () {
            this.$nextTick(() => this.attrResize())
        },
        // IE 2026 09 15: сторона полосы классов / компактные оси — пересчёт полей и высоты
        stripSide: function () { this.$nextTick(() => { this.attrResize(); this.flex?.invalidate() }) },
        compactX: function () { this.compactApply() },
        compactY: function () { this.compactApply() },
        // отбор снят/изменён со стороны чипа воркспейса — перекрасить точки
        pairIds: function () {
            this.syncPairFlags()
            this.$nextTick(() => this.flex?.invalidate())
        },
        // справочник приезжает асинхронно — по его приходу дописываем титулы и перерисовываем
        'store.itemsSource_change_index': function () {
            this.resolveLabels('fill')
            this.refreshPairLabels()
            this.flex?.invalidate()
        },
        // штатный сброс отбора (кнопка на виджете / чекбоксы листа данных) должен
        // сразу перекрашивать точки
        'WIDGET.record.doc.params.flex_havActiveSelectors': function () {
            this.flex?.invalidate()
        },
    },
}
</script>

<style scoped>
.attr-bubble-chart {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-height: 200px;
}
/* height чарта НЕ задаём стилем: в процентах он растягивал контейнер, тот —
   содержимое, и так по кругу (замер: 1755 → 2280 → 2757 px за 6 с).
   Высоту в пикселях ставит attrResize от низа виджета. */
.attr-bubble-chart :deep(.wj-flexchart) {
    width: 100%;
    border: none;
    background: transparent;
}
.attr-bubble-chart {
    position: relative;
}
.bubble-picker {
    position: absolute;
    z-index: 30;
    min-width: 12rem;
    max-width: 22rem;
    padding: 8px 10px;
    border: 1px solid #cfd4dc;
    border-radius: 6px;
    background: var(--surface-card, #fff);
    box-shadow: 0 2px 10px rgba(0, 0, 0, .18);
    font-size: 12px;
}
.bubble-picker-row {
    /* IE 2026 09 16 (уточнение Игоря): без переносов — одна строка, лишнее «…», полный текст в подсказке (как ячейки грида) */
    display: flex; align-items: center; gap: 4px; min-width: 0;
    white-space: nowrap; overflow: hidden;
}
.bubble-picker-value { flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.bubble-picker-sizepi { display: inline-block; width: 10px; height: 10px; margin-right: 4px; border-radius: 50%; border: 2px solid #6366f1; box-sizing: border-box; vertical-align: -1px; }
.bubble-picker-name {
    color: #888; flex: none;
}
/* номер выделенной точки (SVG text из drawString) */
.attr-bubble-chart :deep(.bubble-sel-num) {
    font: bold 11px sans-serif;
    fill: #4a148c;
    paint-order: stroke;
    stroke: #fff;
    stroke-width: 3px;
}
.bubble-picker-dot {
    display: inline-block;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    margin: 0 2px;
    vertical-align: -1px;
}
.bubble-picker-sep {
    height: 1px;
    margin: 6px 0;
    background: #e5e7eb;
}
/* IE 2026 09 15 / ODOO-…: кнопки сброса масштаба и легенды — в островке .corner-island (Widget.vue) в ряд, свои смещения не нужны */
.bubble-picker-hint {
    color: #888;
    max-width: 14rem;
    margin-top: 6px;
}
/* IE 2026 09 15 (замечание Игоря): строки измерений плашки — чекбокс отбора и иконка открытия записи перед заголовком */
.bubble-picker-dim { display: flex; align-items: center; gap: 5px; }
.bubble-picker-check { cursor: pointer; color: var(--cs-accent, #647eff); font-size: 13px; flex: none; position: relative; top: 1px; }
.bubble-picker-check:hover { filter: brightness(0.85); }
.bubble-picker-open { cursor: pointer; color: #8a8494; font-size: 12px; flex: none; position: relative; top: 1px; }
.bubble-picker-open:hover { color: var(--cs-accent, #647eff); }
/* IE 2026 09 15 (замечание Игоря): островок масштаба — кнопки как у карты; вечером 15.09 — в нижнем ПРАВОМ углу */
.bubble-zoom-island { top: auto !important; left: auto !important; gap: 4px !important; padding: 4px 6px !important; }
/* IE 2026 09 15 (замечание Игоря, вечер): подписи значений узла на осях (как теги точки у графика) и кольцо подсветки узла под курсором */
:deep(.bubble-hover-tag) { position: absolute; z-index: 5; pointer-events: none; display: none; padding: 0 5px; border: 1.5px solid #444; border-radius: 3px;
    background: rgba(255, 255, 255, .95); font-size: 11px; font-weight: 600; line-height: 16px; white-space: nowrap; color: #1f2937; }
:deep(.bubble-hover-ring) { position: absolute; z-index: 4; pointer-events: none; display: none; box-sizing: border-box; border-radius: 50%;
    border: 2px dashed #1f2937; box-shadow: 0 0 0 2px rgba(255, 255, 255, .85); }
/* IE 2026 09 16 (замечание Игоря): приколотая кликом плашка — рамка акцентом; прямоугольник выбора узлов (Shift + протяжка) */
.bubble-rect-sel { position: absolute; z-index: 6; pointer-events: none; border: 1.5px dashed #4f46e5; background: rgba(99, 102, 241, .08); border-radius: 2px; }
.bubble-zoombtn {
    display: inline-flex; align-items: center; justify-content: center; width: 24px; height: 20px;
    border: 1px solid #c9ced6; border-radius: 4px; background: #fff; cursor: pointer; color: #2f3b52; font-size: 12px;
}
.bubble-zoombtn:hover { background: #eef1f5; }
/* заголовки осей в компактном режиме — подписи внутри области */
.bubble-axis-title { position: absolute; z-index: 5; font-size: 11px; font-style: italic; color: #6b7280; pointer-events: none;
    background: rgba(255, 255, 255, 0.7); padding: 0 4px; border-radius: 4px; max-width: 45%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
/* Float со скрытыми табами: шапка лежит поверх содержимого — подпись оси Y ниже островков шапки */
.WIDGET.widget-float-header.widget-hide-tabs:not(.widget-hide-header) .bubble-axis-title-y { top: 52px !important; }
:deep(.bubble-axis-inside) { paint-order: stroke; stroke: rgba(255, 255, 255, 0.85); stroke-width: 3px; }
/* полоса классов сбоку / сверху (Legend position) */
.attr-bubble-chart.bubble-strip-top { flex-direction: column-reverse; justify-content: flex-end; }
.attr-bubble-chart.bubble-strip-left { flex-direction: row-reverse; }
.attr-bubble-chart.bubble-strip-right { flex-direction: row; }
.bubble-strip-left :deep(.wj-flexchart), .bubble-strip-right :deep(.wj-flexchart) { width: auto; flex: 1 1 0; min-width: 0; }
.bubble-strip-left .bubble-levels, .bubble-strip-right .bubble-levels { flex-direction: column; flex-wrap: nowrap; gap: 4px; max-width: 200px; overflow: auto; align-self: flex-start; padding-top: 6px; }
/* легенда классов обеспеченности — не спорит с плашкой и кнопками углов */
/* отдельная строка ПОД чартом (не поверх): полоса накрывала подпись оси X
   (репорт Андрея 09.08); высоту строки учитывает attrResize */
.bubble-levels {
    flex: 0 0 auto;
    display: flex;
    flex-wrap: wrap;
    gap: 10px 12px;
    font-size: 11px;
    color: #666;
    padding: 2px 6px 3px;
}
.bubble-levels .bubble-level-clickable {
    cursor: pointer;
    user-select: none;
}
.bubble-levels .bubble-level-off {
    opacity: .45;
    text-decoration: line-through;
}
.bubble-levels i {
    display: inline-block;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    margin-right: 4px;
    vertical-align: -1px;
}
.bubble-picker-buttons {
    display: flex;
    gap: 6px;
    margin-top: 8px;
}
.bubble-chart-empty {
    padding: 12px;
    color: #888;
    font-size: 12px;
}
/* IE 2026 08 15 / ODOO-4997: мини-столбики прихода/расхода у точек —
   скруглённые углы (SVG2: rx как CSS-свойство) */
:deep(.bubble-flow-bar) {
    rx: 1.6px;
}

/* IE 2026 09 16 (метрики пузырьками): подписи плотной категориальной оси Y — кегль по высоте строки (catAxisFont) */
.attr-bubble-chart .wj-flexchart.bubble-cat-y .wj-axis-y text { font-size: var(--bubble-ylabel, 11px) !important; }

/* IE 2026 09 16 (замечание Игоря): при плотной категориальной оси подписи прячутся — полное имя строки показывает тег Y по наведению */
:deep(.bubble-hover-tag-y) { max-width: 55%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-weight: 600; }

/* IE 2026 09 16 (уточнение Игоря): группы плашки узла как в легенде */
.bubble-picker-head { font-size: 10px; line-height: 14px; letter-spacing: .04em; text-transform: uppercase; color: #6b7280; margin-top: 3px; white-space: nowrap; }
.bubble-picker-head:first-child { margin-top: 0; }
.bubble-picker-keyrow .bubble-picker-name { color: #374151; font-weight: 600; }
.bubble-picker-axispi { display: inline-block; width: 11px; height: 11px; margin-right: 5px; box-sizing: border-box; vertical-align: -1px; position: relative; }
.bubble-picker-axispi-x { border-bottom: 2px solid #6366f1; }
.bubble-picker-axispi-x::after { content: ''; position: absolute; right: -1px; bottom: -4px; border: 3px solid transparent; border-left: 5px solid #6366f1; }
.bubble-picker-axispi-y { border-left: 2px solid #6366f1; }
.bubble-picker-axispi-y::after { content: ''; position: absolute; left: -4px; top: -1px; border: 3px solid transparent; border-bottom: 5px solid #6366f1; }
.bubble-picker-sizepi { margin-right: 5px; }
</style>
